import React, { useEffect, useState, useMemo } from "react";
import { Render, FieldLabel, DropZone } from "@measured/puck";
//import Input from "../../../../core/Inputs/DefaultInput";
// import bannerImg from "../../assets/images/lead-gen-form.jpg";
import { useDispatch, useSelector } from "react-redux";
import { GetToken } from "../../store/actions/tokenAction";
import "./styles/style.css";
import { Link } from "react-router-dom";
import DAlogo from "./images/DAlogo.png";
import Svg from "../../../common/Svg";
import Axios from "axios";
import { isLeadFormFieldHidden } from "../../utils/leadFormFieldUtils";

import {
  checkPublish,
  getLeadFormData,
  submitLeadFormData,
  updateSubmitedSurveyByEloqua,
} from "../../store/actions/leadFormAction";

// import {
//   getLandingPageData,
//   getLeadIndicatorSummaryData
// } from "../../store/actions/landingPageAction";

import CustomInput from "./components/CustomInput";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// import SurveyImage1 from '../../assets/images/survey-landing-page/banner-image-1.jpg'
// import SurveyImage2 from '../../assets/images/survey-landing-page/banner-image-2.jpg'
// import AccordionSectionImage from '../../assets/images/survey-landing-page/accordion-section-img.jpg'
// import TabSectionImage from '../../assets/images/survey-landing-page/tab-section-image.jpg'
import theme__ from "../../../common/ThemeSettings";

// import pucksettings from "../../../common/PuckEditorSettings";
import CryptoJS from 'crypto-js';
import { initializeApp, getApps, getApp } from "firebase/app";
import { getAuth, signInWithCustomToken } from "firebase/auth";

// Helper function for HubSpot API calls
const hubspotFetch = (url, options = {}) => {
  return fetch(url, {
    ...options,
    headers: {
      "Content-Type": "application/json",
      "Authorization": "Bearer pat-na1-be76cce0-0edf-484c-924a-89e4a667fd59",
      ...(options.headers || {})
    }
  });
};

// Firebase config (from env)
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
};

// LocalStorage helpers for user_config
const readUserConfig = () => {
  try {
    const raw = localStorage.getItem('user_config');
    return raw ? JSON.parse(raw) : {};
  } catch (e) {
    return {};
  }
};

const saveUserConfig = (obj) => {
  try {
    localStorage.setItem('user_config', JSON.stringify(obj ?? {}));
  } catch (e) {
    // no-op
  }
};

const getCustomTokenFromURL = () => {
  const url = new URL(window.location.href);
  const token = url.searchParams.get('customToken');
  if (token) {
    url.searchParams.delete('customToken');
    window.history.replaceState({}, '', url.toString());
  }
  return token;
};

const buildLoginUrl = (ehValue) => {
  const loginUrl = new URL('https://tatacomms.letschbang.com/login');
  loginUrl.searchParams.set('id', ehValue);
  const params = new URLSearchParams(window.location.search);
  ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'lid'].forEach((key) => {
    const value = params.get(key);
    if (value) {
      loginUrl.searchParams.set(key, value);
    }
  });
  return loginUrl.toString();
};

export default function LandingPage() {
  toast.success("This is a success message!");
  toast.error("This is an error message!");

  //Store config
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { leadFormData } = useSelector((state) => state?.survey?.leadFormData);
  const { publishData } = useSelector((state) => state?.survey?.publishData);
  const { showLandingPage } = useSelector(
    (state) => state?.survey?.showLandingPage
  );
  console.log(showLandingPage);

  const [flagLandingPage, setFlagLandingPage] = useState(0);
  const { survey_id } = useParams();
  const [searchparams] = useSearchParams();
  const hasEParam = searchparams.has('e');
  const hasCustomToken = searchparams.has('customToken');
  const secretKey = "a3dcb4d229de6fde0db5686dee47145d2b34fdf032f7d7c3d3ff7e5cd7eb617a";

  const [decryptedEmail, setDecryptedEmail] = useState('');
  const [userData, setUserData] = useState(null);
  const [displayForm, setDisplayForm] = useState('Before Survey');
  const [displayFormLoaded, setDisplayFormLoaded] = useState(false);

  // useEffect(() => {
  //   if (
  //     survey_id === 'b6420220-5ba7-11ef-b484-6dfb5d512f67' &&
  //     hasEParam
  //   ) {
  //     const encryptedEmail = searchparams.get('e');
  //     if (!encryptedEmail) return;
  //     try {
  //       const bytes = CryptoJS.AES.decrypt(encryptedEmail, secretKey);
  //       const email = bytes.toString(CryptoJS.enc.Utf8);
  //       setDecryptedEmail(email);
  //       if (email) {
  //         fetchUserData(email);
  //       }
  //     } catch (err) {
  //       // Optionally handle error
  //     }
  //   }
  // }, [survey_id, hasEParam, searchparams]);

  const fetchUserData = async (email) => {
    //const apiURL = "/survey/hubspot-contact-by-email"; // Updated backend endpoint
    const apiURL = `${process.env.REACT_APP_API_URL}/survey/hubspot-contact-by-email`; // Updated backend endpoint
   
    try {
      const response = await fetch(apiURL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json"
        },
        body: JSON.stringify({ user_email: email })
      });
      const result = await response.json();
      if (result.results && result.results.length > 0) {
        setUserData(result.results[0].properties);
      }
    } catch (error) {
      // Optionally handle error
    }
  };

  useEffect(() => {
    if (
      survey_id === 'b6420220-5ba7-11ef-b484-6dfb5d512f67' &&
      userData &&
      (flagLandingPage === 1 || flagLandingPage === 2)
    ) {
      formik.setValues({
        ...formik.values,
        email: userData.email || '',
        firstName: userData.firstname || '',      // Name field
        lastName: userData.lastname || '',        // Last Name field
        company: userData.company || '',
        // Normalize phone (remove + and country code if needed)
        busPhone: userData.phone
        ? userData.phone.replace(/^(\+91[\s-]*)/, '')
        : '',
        // Normalize state (to match dropdown value)
        state: userData.state || 'Sinajana Municipality',
        // Normalize designation (to match dropdown value)
        designation: userData.designation_  || 'CISO or C-Level equivalent',
        country: userData.country || '',
        TANDC: "on", // <-- This will check the checkbox
      });
      setTimeout(() => {
        formik.submitForm();
        // After form submit, call patchAPI with hs_object_id
        if (userData.hs_object_id) {
          localStorage.setItem('hs_object_id', userData.hs_object_id);
          fetch(`${process.env.REACT_APP_API_URL}/survey/patchAPI`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
            body: `userId=${encodeURIComponent(userData.hs_object_id)}&action=completion_status&value=0`
          });
        }
      }, 500);
    }
  }, [survey_id, userData, flagLandingPage]);

  useEffect(() => {
    // Removed auto-redirect. Navigation to TataComms login will now happen on explicit "Start Assessment" click.
  }, [survey_id, hasEParam, hasCustomToken]);

  // Handle Firebase customToken on Landing Page → sign in, store email, and redirect to Thank You if a saved ss_id exists
  useEffect(() => {
    const tokenInQuery = getCustomTokenFromURL();
    if (!tokenInQuery) return;

    if (!firebaseConfig.apiKey) {
      console.error('Firebase config missing. Ensure REACT_APP_FIREBASE_* env vars are set and restart the dev server.');
      return;
    }

    try {
      const app = getApps().length ? getApp() : initializeApp(firebaseConfig);
      const auth = getAuth(app);
      signInWithCustomToken(auth, tokenInQuery)
        .then((cred) => {
          const email = cred?.user?.email || '';
          const uid = cred?.user?.uid || '';
          const current = readUserConfig();
          // Save user_config with email + uid
                    console.log("cred--",cred)

          console.log("email--",email)
          saveUserConfig({ ...current, email, uid })
          // If this is the specific survey, mirror the old eParam flow: use email to fetch HubSpot data
          if (survey_id === 'b6420220-5ba7-11ef-b484-6dfb5d512f67') {
              // Ensure Landing shows the lead form (not the Start button) after successful token sign-in
             setFlagLandingPage(1);

              fetchUserData(email);

          }

          const savedId = localStorage.getItem('thankyou_ss_id');
          if (savedId || !survey_id==="b6420220-5ba7-11ef-b484-6dfb5d512f67") {
            navigate(`/thank-you/${survey_id}/${savedId}`, { replace: true });
          }
        })
        .catch((err) => {
          console.error('Firebase custom token sign-in failed on Landing Page:', err);
        });
    } catch (e) {
      console.error('Firebase init/signin error on Landing Page:', e);
    }
  }, [survey_id, navigate]);

  // useEffect(() => {
  //   if (survey_id === 'b6420220-5ba7-11ef-b484-6dfb5d512f67' && hasEParam) {
  //     const encryptedEmail = searchparams.get('e');
  //     //console.log('Encrypted email param:', encryptedEmail);
  //     if (!encryptedEmail) {
  //       //console.warn('No encrypted email value found in URL.');
  //       //alert('No encrypted email value found in URL.');
  //       return;
  //     }
  //     try {
  //       const bytes = CryptoJS.AES.decrypt(encryptedEmail, secretKey);
  //       const decryptedEmail = bytes.toString(CryptoJS.enc.Utf8);
  //       if (!decryptedEmail) {
  //         //console.warn('Decryption produced an empty string.');
  //         //alert('Decryption produced an empty string.');
  //       }
  //       console.log('Decrypted email:', decryptedEmail);
  //       //alert('Decrypted email: ' + decryptedEmail);
  //     } catch (err) {
  //       console.error('Failed to decrypt email:', err);
  //       //alert('Failed to decrypt email: ' + err);
  //     }
  //   } else if (survey_id === 'b6420220-5ba7-11ef-b484-6dfb5d512f67') {
  //     console.log('No e parameter in URL.');
  //     //alert('No e parameter in URL.');
  //   }
  // }, [survey_id, hasEParam, searchparams]);

  const [heading, setHeading] = useState("");
  const [submitTitle, setSubmitTitle] = useState("");
  const [submitPosition, setSubmitPosition] = useState("Left");
  const [TandC, setTandC] = useState("");
  const [TandCOption, setTandCOption] = useState("");
  const [TandCSecond, setTandCSecond] = useState("");
  const [TandCSecondOption, setTandCSecondOption] = useState("");
  const [TandCThird, setTandCThird] = useState("");
  const [TandCThirdOption, setTandCThirdOption] = useState("");
  const [emailVerify, setEmailVerify] = useState(false);
  const [emailValidationTiming, setEmailValidationTiming] = useState("");
  //const [otpError, setotpError] = useState(false);
  const [leadId, setLeadId] = useState("");
  const [otp, setOtp] = useState("");
  const [otpError, setotpError] = useState(false);
  const [checkotp, setcheckotp] = useState("");
  const [timerStarted, setTimerStarted] = useState(false);
  const [timer, setTimer] = useState(600);
const [redirected, setRedirected] = useState(false);

  const params = {};

  // AI Landing Page Params
  const [aiLandingSection2Heading, setAiLandingSection2Heading] = useState("");
  const [aiLandingSection2Desc1, setAiLandingSection2Desc1] = useState("");
  const [aiLandingSection2Desc2, setAiLandingSection2Desc2] = useState("");
  const [aiLandingSection2Desc3, setAiLandingSection2Desc3] = useState("");

  const [aiLandingTopic, setAiLandingTopic] = useState("");
  const [aiLandingAssesmentName, setAiLandingAssesmentName] = useState("");
  const [aiLandingCompanyName, setAiLandingCompanyName] = useState("");

  const [aiLandingLeadIndicator0Name, setAiLandingLeadIndicator0Name] =
    useState("");
  const [aiLandingLeadIndicator1Name, setAiLandingLeadIndicator1Name] =
    useState("");
  const [aiLandingLeadIndicator2Name, setAiLandingLeadIndicator2Name] =
    useState("");
  const [aiLandingLeadIndicator3Name, setAiLandingLeadIndicator3Name] =
    useState("");
  const [aiLandingLeadIndicator4Name, setAiLandingLeadIndicator4Name] =
    useState("");
  const [aiLandingLeadIndicator5Name, setAiLandingLeadIndicator5Name] =
    useState("");

  const [aiLandingLeadIndicator0Desc, setAiLandingLeadIndicator0Desc] =
    useState("");
  const [aiLandingLeadIndicator1Desc, setAiLandingLeadIndicator1Desc] =
    useState("");
  const [aiLandingLeadIndicator2Desc, setAiLandingLeadIndicator2Desc] =
    useState("");
  const [aiLandingLeadIndicator3Desc, setAiLandingLeadIndicator3Desc] =
    useState("");
  const [aiLandingLeadIndicator4Desc, setAiLandingLeadIndicator4Desc] =
    useState("");
  const [aiLandingLeadIndicator5Desc, setAiLandingLeadIndicator5Desc] =
    useState("");

  const [aiLandingStage0Name, setAiLandingStage0Name] = useState("");
  const [aiLandingStage1Name, setAiLandingStage1Name] = useState("");
  const [aiLandingStage2Name, setAiLandingStage2Name] = useState("");
  const [aiLandingStage3Name, setAiLandingStage3Name] = useState("");
  const [aiLandingStage4Name, setAiLandingStage4Name] = useState("");
  const [aiLandingStage5Name, setAiLandingStage5Name] = useState("");

  const [aiLandingStage0Desc, setAiLandingStage0Desc] = useState("");
  const [aiLandingStage1Desc, setAiLandingStage1Desc] = useState("");
  const [aiLandingStage2Desc, setAiLandingStage2Desc] = useState("");
  const [aiLandingStage3Desc, setAiLandingStage3Desc] = useState("");
  const [aiLandingStage4Desc, setAiLandingStage4Desc] = useState("");
  const [aiLandingStage5Desc, setAiLandingStage5Desc] = useState("");

  const [heroImage, setHeroImage] = useState("");
  const [section2, setSection2] = useState("");
  const [section3, setSection3] = useState("");
  const [leadgenImage, setLeadgenImage] = useState("");
  const [leadImage, setLeadImage] = useState("");

  const [leadManagementPlugin, setLeadManagementPlugin] = useState(0);

  //Puck editor state
  const [landingConent, setLandingConent] = useState([]);
  const [loading, setLoading] = useState(true);
  const [subLoading, setSubLoading] = useState(false);
  const [surveyLinkUrl, setSurveyLinkUrl] = useState(1);
  searchparams.forEach((value, key) => {
    params[key] = value;
  });
  //Language
  const language = localStorage.getItem("customer_language") ?? "22";
  useEffect(() => {
    console.log(showLandingPage);
    setFlagLandingPage(showLandingPage);
  }, [showLandingPage]);

  // IMPORTANT: Define function BEFORE the useEffect that uses it
  const initDummyAndGo = async () => {
    try {
      const urlParams = new URLSearchParams(window.location.search);
      const su_link_info = {
        utm_source: urlParams.get("utm_source") || "",
        utm_medium: urlParams.get("utm_medium") || "",
        utm_campaign: urlParams.get("utm_campaign") || "",
        utm_content: urlParams.get("utm_content") || "",
      };
      const { data } = await Axios.post(
        `${process.env.REACT_APP_API_URL}/frnt/init-session`,
        { survey_id, su_link_info }
      );
      setLeadId(data.ss_id);
      navigate(`/qna/${survey_id}/${data.ss_id}`, { replace: true });
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    if (displayForm === 'Before report' && !redirected && !hasCustomToken) {
      setRedirected(true);
      initDummyAndGo();
    }
  }, [displayForm, redirected, hasCustomToken]);

  //Yup - Schema
  let schemaShape = {};
  const containsHTML = (value) => {
    const htmlTagPattern = /<\/?[a-z][\s\S]*?>/i; // Matches all HTML tags
    return !htmlTagPattern.test(value);
  };

  const noConsecutiveSpecialChars = (value) => {
    const specialCharPattern = /[@$#%^&*!?]{2,}/;
    return !specialCharPattern.test(value);
  };

  const containsForbiddenCharacters = (value) => {
    // Allow only letters (a-z, A-Z), numbers (0-9), and spaces
    const forbiddenPattern = /[^a-zA-Z0-9 ]/;
    return !forbiddenPattern.test(value);
  };


  // for scroll to top lead form 
  useEffect(() => {
    if (
      (publishData === 1 || params.mode === "preview") &&
      (flagLandingPage === 2 || flagLandingPage === 1) &&
      surveyLinkUrl === 1
    ) {
      // Scroll to top when lead-gen-wrapper appears
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [publishData, params.mode, flagLandingPage, surveyLinkUrl]);
  // for scroll to top lead form end

  leadFormData?.forEach((item) => {
    if (isLeadFormFieldHidden(item)) return;

    const title = item.su_label_and_options
      ? JSON.parse(item.su_label_and_options)[language]
      : "";
    const key = item.su_name;

    if (item.su_form_variable_type === 1) {
      const attributes = item.su_options && JSON.parse(item.su_options)["0"];

      if (attributes?.required && attributes?.type === "text") {
        schemaShape[key] = Yup.string()
          .test(
            "Whitespace check",
            `${title} can not start with white space`,
            async (value) => {
              if (!value) return true;
              return value.toString()[0] !== " ";
            }
          )
          .test(
            "No HTML tags or scripts",
            `${title} contains forbidden HTML tags`,
            (value) => !value || containsHTML(value)
          )
          .test(
            "No consecutive special characters",
            `${title} contains special characters`,
            (value) => !value || noConsecutiveSpecialChars(value)
          )
          .test(
            "No forbidden characters",
            `${title} contains invalid characters`,
            (value) => !value || containsForbiddenCharacters(value)
          )
          .max(255, `${title} is too long`)
          .required(`${title} Required`);
      } else if (attributes?.type === "email" && !attributes?.required) {
        schemaShape[key] = Yup.string()
          .email("Invalid email")
          .test(
            "Email check",
            `Please enter valid business email address`,
            async (value) => {
              if (!value) return true;
              if (attributes?.businessEmailVerification === false) {
                return true; // Skip domain check if businessEmailVerification is false
              }
              let domain = value?.split("@");
              domain = domain[1];
              const allowedDomainList = [
                "gmail.com",
                "outlook.com",
                "hotmail.com",
                "yahoo.com",
              ];
              return !allowedDomainList.includes(domain);
            }
          );
      } else if (attributes?.required && attributes?.type === "email") {
        schemaShape[key] = Yup.string()
          .email("Invalid email")
          .test(
            "Email check",
            `Please enter valid business email address`,
            async (value) => {
              if (!value) return true;
              if (attributes?.businessEmailVerification === false) {
                return true; // Skip domain check if businessEmailVerification is false
              }
              let domain = value.split("@");
              domain = domain[1];
              const allowedDomainList = [
                "gmail.com",
                "outlook.com",
                "hotmail.com",
                "yahoo.com",
              ];
              return !allowedDomainList.includes(domain);
            }
          )
          .required(`${title} Required`);
      } else if (attributes?.required && attributes?.type === "checkbox") {
        schemaShape[key] = Yup.array()
          .of(Yup.string())
          .min(1, `${title} Required`);
      } else if (attributes?.type === "checkbox") {
        schemaShape[key] = Yup.array().of(Yup.string());
      } else if (attributes?.required) {
        schemaShape[key] = Yup.string()
          .required(`${title} Required`)
          .max(10, `Invalid number`);
      } else {
        schemaShape[key] = Yup.string()
          .optional()
          .test(
            "Whitespace check",
            `${title} can not start with white space`,
            async (value) => {
              if (!value) return true;
              return value.toString()[0] !== " ";
            }
          )
          .test(
            "No HTML tags or scripts",
            `${title} contains forbidden HTML tags`,
            (value) => !value || containsHTML(value)
          )
          .test(
            "No forbidden characters",
            `${title} contains invalid characters`,
            (value) => !value || containsForbiddenCharacters(value)
          )
          .test(
            "No consecutive special characters",
            `${title} contains special characters`,
            (value) => !value || noConsecutiveSpecialChars(value)
          )
          .max(255, `${title} is too long`);
      }
    } else if (item.su_form_variable_type === 3) {
      const attributes = item?.su_options && JSON.parse(item.su_options);
      if (attributes?.required) {
        schemaShape[key] = Yup.string().required(`${title} Required`);
      } else {
        schemaShape[key] = Yup.string();
      }
    } else if (item.su_form_variable_type === 4) {
      const attributes = item?.su_options && JSON.parse(item.su_options);
      if (attributes?.required) {
        schemaShape[key] = Yup.string()
          .required(`${title} Required`)
          .test(
            "No HTML tags or scripts",
            `${title} contains forbidden HTML tags`,
            (value) => !value || containsHTML(value)
          );
      } else {
        schemaShape[key] = Yup.string()
          .optional()
          .test(
            "No HTML tags or scripts",
            `${title} contains forbidden HTML tags`,
            (value) => !value || containsHTML(value)
          );
      }
    } else if (item.su_form_variable_type === 99 && item.su_name === "TANDC") {
      let tancRequired = item?.su_options && JSON.parse(item?.su_options);
      tancRequired = tancRequired ? tancRequired.required : false;
      tancRequired = tancRequired ? true : false;
      // if (tancRequired)
      //     schemaShape[key] = Yup.array()
      //         .of(Yup.string())
      //         .min(1, `Please accept conditions to go ahead`);
      // else schemaShape[key] = Yup.array().of(Yup.string());
      let tancTerm = item?.su_options && JSON.parse(item?.su_options);
      tancTerm = tancTerm ? tancTerm.term : false;
      tancTerm = tancTerm ? true : false;
      if (tancRequired && tancTerm) {
        schemaShape[key] = Yup.string()
          .oneOf(["on"], "")
          .required("Please accept conditions to go ahead");
      } else {
        schemaShape[key] = Yup.string();
      }
    } else if (
      item.su_form_variable_type === 99 &&
      item.su_name === "TANDCSECOND"
    ) {
      let tancRequired = item?.su_options && JSON.parse(item?.su_options);
      tancRequired = tancRequired ? tancRequired.required : false;
      tancRequired = tancRequired ? true : false;
      let tancTerm = item?.su_options && JSON.parse(item?.su_options);
      tancTerm = tancTerm ? tancTerm.term : false;
      tancTerm = tancTerm ? true : false;
      if (tancRequired && tancTerm) {
        schemaShape[key] = Yup.string()
          .oneOf(["on"], "")
          .required("Please accept conditions to go ahead");
      } else {
        schemaShape[key] = Yup.string();
      }
    } else if (
      item.su_form_variable_type === 99 &&
      item.su_name === "TANDCTHIRD"
    ) {
      let tancRequired = item?.su_options && JSON.parse(item?.su_options);
      tancRequired = tancRequired ? tancRequired.required : false;
      tancRequired = tancRequired ? true : false;
      let tancTerm = item?.su_options && JSON.parse(item?.su_options);
      tancTerm = tancTerm ? tancTerm.term : false;
      tancTerm = tancTerm ? true : false;
      if (tancRequired && tancTerm) {
        schemaShape[key] = Yup.string()
          .oneOf(["on"], "")
          .required("Please accept conditions to go ahead");
      } else {
        schemaShape[key] = Yup.string();
      }
    } else if (item.su_form_variable_type === 12) {
      const attributes = item?.su_options && JSON.parse(item.su_options);
      if (attributes?.required) {
        schemaShape[key] = Yup.string().required(`${title} Required`);
      } else {
        schemaShape[key] = Yup.string();
      }
    } else if (item.su_form_variable_type === 13) {
      const attributes = item?.su_options && JSON.parse(item.su_options);
      if (attributes?.required) {
        schemaShape[key] = Yup.string().required(`${title} Required`);
      } else {
        schemaShape[key] = Yup.string();
      }
    }
  });

  const htmlDecode = (input) => {
    const textArea = document.createElement("textarea");
    textArea.innerHTML = input;
    return textArea.value;
  };

  //Formik
  const Schema = Yup.object().shape(schemaShape);
  const formik = useFormik({
    validationSchema: Schema,
    onSubmit: async (values) => {
      // Get the query string from the URL
      const queryString = window.location.search;

      // Create a URLSearchParams object
      const params = new URLSearchParams(queryString);
      const utm_source = params.get("utm_source");
      const utm_medium = params.get("utm_medium");
      const utm_campaign = params.get("utm_campaign");
      const utmContent = params.get("utm_content");
      // Create su_lead_info object with all UTM variables and other params
      const suLeadInfo = {
        utm_source: utm_source || "",
        utm_medium: utm_medium || "",
        utm_campaign: utm_campaign || "",
        utm_content: utmContent || "",
        ...Object.fromEntries(
          Object.entries(params).filter(([key]) => 
            !['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'].includes(key)
          )
        )
      };

      const payload = {
        lead_data: {
          ...values,
          natureOfEnquiry: "More info on Cloud and Hosting",
        },
        survey_id: survey_id,
        su_lead_info: JSON.stringify(suLeadInfo),
        lid: params.lid,
        leadManagementPlugin: leadManagementPlugin,
        emailVerification: emailVerify,
        emailValidationTiming: emailValidationTiming,
        utm_campaign: utm_campaign || "default_campaign",
        utm_medium: utm_medium || "default_medium",
        utm_source: utm_source || "default_source",
      };
      if (emailVerify === true && emailValidationTiming === "before") {
        setFlagLandingPage(2);
        //dispatch(submitLeadFormData(payload, navigate));
        try {
          const response = await dispatch(
            submitLeadFormData(payload, navigate)
          );
          setSubLoading(true);
          const { ss_id, msg, result } = response;
          setLeadId(ss_id);
          //console.log('Form submission successful:', response); // This should log the response data
        } catch (error) {
          setSubLoading(false);
          console.error("Form submission failed:", error);
        }
      } else {
        dispatch(submitLeadFormData(payload, navigate));
        setSubLoading(true);
      }
    },
  });

  const [theme, setTheme] = useState(-1);
  const [themeSet, setThemeSet] = useState([]);

  const checkSurveyLinkUrl = (surveyLinkId) => {
    Axios.post(process.env.REACT_APP_API_URL + "/frnt/getSurveyLinkById", {
      survey_link_id: surveyLinkId,
    })
      .then((response) => {
        if (response.data.data[0].is_active === 1) {
          setSurveyLinkUrl(1);
        } else {
          setSurveyLinkUrl(0);
        }
      })
      .catch((error) => {
        console.error("Error survey link:", error);
      });
  };

  useEffect(() => {
    console.log("1");
    if (params.lid) {
      checkSurveyLinkUrl(params.lid);
    }
  }, []);
  useEffect(() => {
    console.log("2");
    localStorage.setItem("customer_language", "22");
    dispatch(GetToken()).then(() => {
      dispatch(checkPublish({ survey_id }));
    });
  }, []);

  //Effects
  useEffect(() => {
    console.log("3");
    // if (publishData === 1 || params.mode === "preview") {
    dispatch(GetToken()).then(() => {
      dispatch(getLeadFormData({ survey_id }, navigate));
    });

    // }
  }, [publishData]);

  useEffect(() => {
    console.log("4");
    if (leadFormData?.length > 0) {
      let tmpinitialValues = {};
      let tmpinitialTouched = {};

      setTandC("");
      setTandCSecond("");
      setTandCThird("");
      setTandCOption("");
      setTandCSecondOption("");
      setTandCThirdOption("");

      leadFormData?.forEach((item) => {
        if (isLeadFormFieldHidden(item)) return;

        const key = item.su_name;
        tmpinitialValues[key] = "";
        tmpinitialTouched[key] = false;

        if (Number(item.su_form_variable_type) === 1) {
          let options = item?.su_options && JSON.parse(item?.su_options);
          if (options["0"].type === "checkbox") {
            tmpinitialValues[key] = [];
          }
        }
        if (Number(item.su_form_variable_type) === 5) {
          let options = item?.su_options && JSON.parse(item?.su_options);
          if (options["0"].type === "hidden") {
            tmpinitialValues[key] = options["0"].defaultValue;
          }
        }

        if (item.su_name === "HEADING") {
          const tmpHeading =
            item.su_label_and_options &&
            JSON.parse(item.su_label_and_options)[language];
          setHeading(tmpHeading);
        }

        if (item.su_name === "SUBMIT") {
          const tmpHeading =
            item.su_label_and_options &&
            JSON.parse(item.su_label_and_options)[language];
          let position = item.su_options && JSON.parse(item.su_options);
          position = position ? position.alignment : "Left";
          position =
            position === "Left"
              ? "start"
              : position === "Right"
              ? "end"
              : "center";
          setSubmitPosition(position);
          setSubmitTitle(tmpHeading);
        }

        if (item.su_name === "TANDC") {
          const tmpHeading =
            item.su_label_and_options &&
            JSON.parse(item.su_label_and_options)[language];
          const tmpOptions = item.su_options && JSON.parse(item.su_options);
          setTandC(htmlDecode(tmpHeading));
          setTandCOption(tmpOptions);
          tmpinitialValues["TANDC"] = "";
        }

        if (item.su_name === "TANDCSECOND") {
          const tmpHeading =
            item.su_label_and_options &&
            JSON.parse(item.su_label_and_options)[language];
          const tmpOptions = item.su_options && JSON.parse(item.su_options);
          setTandCSecond(htmlDecode(tmpHeading));
          setTandCSecondOption(tmpOptions);
          tmpinitialValues["TANDCSECOND"] = "";
        }

        if (item.su_name === "TANDCTHIRD") {
          const tmpHeading =
            item.su_label_and_options &&
            JSON.parse(item.su_label_and_options)[language];
          const tmpOptions = item.su_options && JSON.parse(item.su_options);
          setTandCThird(htmlDecode(tmpHeading));
          setTandCThirdOption(tmpOptions);
          tmpinitialValues["TANDCTHIRD"] = "";
        }

        if (item.su_name === "email") {
          const suOptions = JSON.parse(item?.su_options);
          const emailVerification = suOptions[0]?.emailVerification;
          const emailValidationTime = suOptions[0]?.emailValidationTiming;
          setEmailVerify(emailVerification);
          setEmailValidationTiming(emailValidationTime);
        }
      });
      formik.setTouched(tmpinitialTouched);
      formik.setValues(tmpinitialValues);
    }
     const row = leadFormData.find(r => r.su_name === 'DISPLAYFORM');
  if (row) {
    
    const val = JSON.parse(row.su_options)?.value || 'Before survey';
    setDisplayForm(val);
    setDisplayFormLoaded(true);
  }
  }, [language, leadFormData]);

  useEffect(() => {
    console.log("5");
    dispatch(GetToken()).then(() => {
      dispatch(checkPublish({ survey_id })).then((resp) => {
        console.log("resp======", resp);
        // if (flagLandingPage === 1 || params.mode === "preview") {
        localStorage.setItem("customer_language", "22");
        GetSurveyDetails(survey_id);
        GetLandingPage(survey_id, "landing_page");
        GetLeadIndicatorSummaryData(survey_id, "lead_indicator_summary");
        GetStageSummaryData(survey_id, "stage_summary");
        // }
      });
    });
  }, [flagLandingPage]);

  //Effects
  useEffect(() => {
    console.log("6");
    setThemeSet(theme__[theme]);
  }, [theme]);

  const GetSurveyDetails = function (survey_id) {
    let token = localStorage.getItem("customer_token");
    // add header in axios
    Axios.defaults.headers.common["Authorization"] = "Bearer " + token;
    Axios.defaults.headers.common["Accept"] = "application/json";
    Axios.post(
      process.env.REACT_APP_API_URL +
        "/aiLanding/getAiSurveyDetail?survey_id=" +
        survey_id
    ).then((response) => {
      //setCurrentItem(11);
      // console.log(response)
      if (response.data.statusCode === 200) {
        //alert("successfull! and ID is: " + response.data.data[0].topic_name);

        //setAiLandingMainHeading(response.data.data[0].topic_name);

        // debugger;
        setAiLandingTopic(response.data.data[0]?.topic_name);
        setLeadManagementPlugin(response.data.data[0]?.lead_management_plugin);

        const suSurveyTitleObj = JSON.parse(
          response.data.data[0]?.su_survey_title
        );

        // Extract the value for the key '22'
        const suSurveyTitleValue = suSurveyTitleObj["22"];

        // Log the results
        // console.log(`su_survey_title: ${suSurveyTitleValue}`);

        setAiLandingAssesmentName(suSurveyTitleValue);
        setAiLandingCompanyName(response.data.data[0]?.company_name);
        setTheme(response.data.data[0]?.theme_selected);
        let images = response.data?.data?.[0]?.landing_page_images
          ? JSON.parse(response.data.data[0].landing_page_images)
          : {};
        let leadFormImage = response.data.data[0]?.lead_form_image;
        setLeadImage(leadFormImage);
        setHeroImage(images["hero_image"]);
        setSection2(images["section2_image"]);
        setSection3(images["section3_image"]);
        setLeadgenImage(images["leadgen_image"]);
      } else {
        alert("Try Again, Error");
      }
    });
  };
  const GetLandingPage = function (su_survey_id, su_component_type) {
    let token = localStorage.getItem("customer_token");

    // add header in axios
    Axios.defaults.headers.common["Authorization"] = "Bearer " + token;
    Axios.defaults.headers.common["Accept"] = "application/json";

    Axios.post(
      process.env.REACT_APP_API_URL + "/aiLanding/getAiLandingPageDetail",
      { su_survey_id: su_survey_id, su_component_type: su_component_type }
    ).then((response) => {
      //setCurrentItem(11);

      //console.log(response)
      if (response.data.statusCode === 200) {
        //alert("successfull! and ID is: " + response.data.data);

        const suValueObj = response.data?.data?.[0]?.su_value
          ? JSON.parse(response.data.data[0].su_value)
          : {};

        // Extract values
        const headline = suValueObj.headline;
        const bodyCopy = suValueObj.body_copy;

        setAiLandingSection2Heading(headline);
        setAiLandingSection2Desc1(bodyCopy);

        // Object.keys(suValueObj ?? {})?.forEach((key, index) => {
        // // Log the results
        // // console.log(`headline: ${headline}`);
        // // console.log(`body_copy:`);
        // //bodyCopy.forEach((copy, index) => {
        //   if (index === 0) {
        //     setAiLandingSection2Desc1(copy);
        //   } else if (index === 1) {
        //     setAiLandingSection2Desc2(copy);
        //   } else if (index === 2) {
        //     setAiLandingSection2Desc3(copy);
        //   }

        // });
      } else {
        alert("Try Again, Error");
      }
    });
  };

  const GetLeadIndicatorSummaryData = function (
    su_survey_id,
    su_component_type
  ) {
    let token = localStorage.getItem("customer_token");

    // add header in axios
    Axios.defaults.headers.common["Authorization"] = "Bearer " + token;
    Axios.defaults.headers.common["Accept"] = "application/json";

    Axios.post(
      process.env.REACT_APP_API_URL + "/aiLanding/getAiLandingPageDetail",
      { su_survey_id: su_survey_id, su_component_type: su_component_type }
    ).then((response) => {
      //setCurrentItem(11);
      if (response.data.statusCode === 200) {
        // alert("successfull! and ID is: " + response.data.data);
        // debugger;

        const suValueArray = response.data?.data?.[0]?.su_value
          ? JSON.parse(response.data.data[0].su_value)
          : {};

        //const sectionWithScore = result?.section_maturity_score

        //console.log(suValueArray);
        Object.keys(suValueArray ?? {})?.forEach((key, index) => {
          const name = suValueArray[key].name;
          const description = suValueArray[key].description;

          // console.log(`Name: ${name}\nDescription: ${description}\n ${index}`);
          // Concatenate the strings and set the state
          if (index === 0) {
            setAiLandingLeadIndicator0Name(name);
            setAiLandingLeadIndicator0Desc(description);
          } else if (index === 1) {
            setAiLandingLeadIndicator1Name(name);
            setAiLandingLeadIndicator1Desc(description);
          } else if (index === 2) {
            setAiLandingLeadIndicator2Name(name);
            setAiLandingLeadIndicator2Desc(description);
          } else if (index === 3) {
            setAiLandingLeadIndicator3Name(name);
            setAiLandingLeadIndicator3Desc(description);
          } else if (index === 4) {
            setAiLandingLeadIndicator4Name(name);
            setAiLandingLeadIndicator4Desc(description);
          } else if (index === 5) {
            setAiLandingLeadIndicator5Name(name);
            setAiLandingLeadIndicator5Desc(description);
          }
        });
      } else {
        alert("Try Again, Error");
      }
    });
  };

  const GetStageSummaryData = function (su_survey_id, su_component_type) {
    let token = localStorage.getItem("customer_token");

    // add header in axios
    Axios.defaults.headers.common["Authorization"] = "Bearer " + token;
    Axios.defaults.headers.common["Accept"] = "application/json";

    Axios.post(
      process.env.REACT_APP_API_URL + "/aiLanding/getAiLandingPageDetail",
      { su_survey_id: su_survey_id, su_component_type: su_component_type }
    ).then((response) => {
      //setCurrentItem(11);

      //console.log(response)
      if (response.data.statusCode === 200) {
        // alert("successfull! and ID is: " + response.data.data);
        // debugger;

        // Parse the JSON string inside su_value
        const suValueObj = response.data?.data?.[0]?.su_value
          ? JSON.parse(response.data.data[0].su_value)
          : {};

        // Extract values
        // const readinessStageIntro = suValueObj.ReadinessStageIntro;
        const businessMaturityStages = suValueObj.BusinessMaturityStages;

        // Log the Readiness Stage Intro
        // console.log(`Readiness Stage Intro:`);
        // console.log(`Heading: ${readinessStageIntro.heading}`);
        // console.log(`Content: ${readinessStageIntro.content}`);
        // console.log('\n');

        // Log information for each Business Maturity Stage
        //console.log(businessMaturityStages);

        Object.keys(businessMaturityStages ?? {})?.forEach((key, index) => {
          //businessMaturityStages.forEach((stage, index) => {
          const title = businessMaturityStages[key].Name;
          const description = businessMaturityStages[key].Description;
          // console.log(`Index: ${index}`);
          // console.log(`Title: ${title}`);
          // console.log(`Description: ${description}`);
          // console.log("\n");

          if (index === 0) {
            setAiLandingStage0Name(title);
            setAiLandingStage0Desc(description);
          } else if (index === 1) {
            setAiLandingStage1Name(title);
            setAiLandingStage1Desc(description);
          } else if (index === 2) {
            setAiLandingStage2Name(title);
            setAiLandingStage2Desc(description);
          } else if (index === 3) {
            setAiLandingStage3Name(title);
            setAiLandingStage3Desc(description);
          } else if (index === 4) {
            setAiLandingStage4Name(title);
            setAiLandingStage4Desc(description);
          } else if (index === 5) {
            setAiLandingStage5Name(title);
            setAiLandingStage5Desc(description);
          }
        });
      } else {
        alert("Try Again, Error");
      }
    });
  };
  const otpVerify = () => {
    if (otp.trim() === "") {
      // OTP field is empty, set error state and display error message
      setotpError(true);
      setcheckotp("Please enter the OTP");
      return; // Exit function
    }
    let payload = {
      lead_id: leadId,
      otp: otp,
    };
    console.log(payload, "payload");
    Axios.post(process.env.REACT_APP_API_URL + "/frnt/verify-email-otp", {
      lead_id: leadId,
      otp: otp,
    })
      .then((response) => {
        if (response.data.data.success === true) {
          toast.success(response.msg);
          navigate(`/qna/${survey_id}/${leadId}`);
        } else {
          setotpError(true);
          setcheckotp("Invalid OTP");
          toast.error(" Please try again later.");
        }
      })
      .catch((error) => {
        console.error("Error signing up:", error);
        toast.error("Unable to send. Please try again later.");
      });
  };

  useEffect(() => {
    console.log("8");
    const fetchSectionData = async () => {
      if (survey_id) {
        try {
          let data = { survey_id: survey_id };
          let response = await Axios.post(
            process.env.REACT_APP_API_URL + "/frnt/getSections",
            data
          );

          if (
            response.data.statusCode === 200 &&
            Array.isArray(response.data.data)
          ) {
            response.data.data.forEach((section, index) => {
              const { su_section_name, su_section_desc } = section;
              const title = JSON.parse(su_section_name)["22"];
              const description = JSON.parse(su_section_desc)["22"];

              switch (index) {
                case 0:
                  setAiLandingLeadIndicator0Name(title);
                  setAiLandingLeadIndicator0Desc(description);
                  break;
                case 1:
                  setAiLandingLeadIndicator1Name(title);
                  setAiLandingLeadIndicator1Desc(description);
                  break;
                case 2:
                  setAiLandingLeadIndicator2Name(title);
                  setAiLandingLeadIndicator2Desc(description);
                  break;
                case 3:
                  setAiLandingLeadIndicator3Name(title);
                  setAiLandingLeadIndicator3Desc(description);
                  break;
                case 4:
                  setAiLandingLeadIndicator4Name(title);
                  setAiLandingLeadIndicator4Desc(description);
                  break;
                case 5:
                  setAiLandingLeadIndicator5Name(title);
                  setAiLandingLeadIndicator5Desc(description);
                  break;
                default:
                  break;
              }
            });
          } else {
            // Handle API response errors or empty data
            // toast.error('Invalid data received from the API');
          }
        } catch (error) {
          // Handle API request or response errors
          // toast.error('Error fetching data from the API');
          // console.error('API error:', error);
        }
      }
    };

    fetchSectionData(); // Call the async function immediately
  }, [survey_id]);

  //Get landing page data
  useEffect(() => {
    console.log("9");
    const data = {
      survey_id: survey_id,
    };
    const url = `${process.env.REACT_APP_API_URL}/landing/getLandingpage`;
    const fetchData = async () => {
      try {
        const response = await Axios.post(url, data);
        if (response.data.response === "200") {
          const suContent = response.data.result[0]?.su_content;
          if (suContent) {
            const parsedContent = JSON.parse(suContent);
            //const replacedContent = replaceDynamicValues(parsedContent);
            //setLandingConent({})
            setLandingConent(parsedContent);
          } else {
            console.log("Error: Empty content received from API");
          }
        } else {
          console.log("Error: Landing page not found");
        }
      } catch (error) {
        console.error("Error:", error);
      } finally {
        setLoading(false); // Set loading state to false after fetching data
      }
    };

    fetchData(); // Call the fetchData function when the component mounts
  }, [survey_id]);
  //console.log("aiLandingLeadIndicator1NameaiLandingLeadIndicator1Name=", aiLandingLeadIndicator1Name)

  const dynamicValues = {
    assessment_name: aiLandingAssesmentName ?? "",
    topic_name: aiLandingTopic ?? "",
    //section2_heading : aiLandingSection2Heading ?? "",
    //section2_desc1 : aiLandingSection2Desc1 ?? "",
    //section2_desc2 : aiLandingSection2Desc2 ?? "",
    //section2_desc3 : aiLandingSection2Desc3 ?? "",
    company_name: aiLandingCompanyName ?? "",
    section_1_name: aiLandingLeadIndicator0Name ?? "",
    //indicator0_desc : setAiLandingLeadIndicator0Desc ?? "",
    section_2_name: aiLandingLeadIndicator1Name ?? "",
    //indicator1_desc : setAiLandingLeadIndicator1Desc ?? "",
    section_3_name: aiLandingLeadIndicator2Name ?? "",
    //indicator2_desc : setAiLandingLeadIndicator2Desc ?? "",
    section_4_name: aiLandingLeadIndicator3Name ?? "",
    //indicator3_desc : setAiLandingLeadIndicator3Desc ?? "",
    section_5_name: aiLandingLeadIndicator4Name ?? "",
    //indicator4_desc : setAiLandingLeadIndicator4Desc ?? "",
    section_6_name: aiLandingLeadIndicator5Name ?? "",
    //indicator5_desc : setAiLandingLeadIndicator5Desc ?? "",
  };
  const replaceDynamicValues = (content, dynamicValues) => {
    if (typeof content === "object") {
      if (Array.isArray(content)) {
        return content.map((item) => replaceDynamicValues(item, dynamicValues));
      } else {
        const replacedObject = {};
        for (const key in content) {
          replacedObject[key] = replaceDynamicValues(
            content[key],
            dynamicValues
          );
        }
        return replacedObject;
      }
    } else if (typeof content === "string") {
      return content.replace(/#\[(.*?)\]#/g, (match, p1) => {
        const dynamicValue = p1.trim();
        return dynamicValues[dynamicValue] ?? match;
      });
    } else {
      return content; // Return unchanged if content is not an object or string
    }
  };

  const replacedContent = replaceDynamicValues(landingConent, dynamicValues);
  const config = {
    components: {
      // Landing Page components
      LandingHeader: {
        fields: {
          logo: {
            type: "custom",
            label: "Add image  (207 × 27 px)",
            render: ({ name, onChange, value, field }) => {
              return (
                <>
                  <FieldLabel label={field.label}></FieldLabel>
                  <input
                    type="file"
                    className="d-none"
                    id="uploadLogo"
                    // name={name}
                    // onChange={handleLogoImage}
                  />
                  {/* <label htmlFor="uploadLogo" className='icon-upload' onClick={() => onChange('')}    >
                                        {value ? (
                                            <>
                                                <button className='remove-btn' onClick={() => onChange('')}>
                                                    <Svg name="remove-icn-roi" />
                                                </button>
                                                <div className={`img-wrapper ${value ? '' : 'd-none'}`}>
                                                    <img src={value} className='img-fluid' alt="" />
                                                </div>
                                            </>
                                        ) : (
                                            <>
                                                <Svg name="upload-icon" />
                                                <span>Upload Image</span>
                                                <div className={`img-wrapper ${value ? '' : 'd-none'}`}>
                                                    <img src="https://survey-bis.s3.ap-south-1.amazonaws.com/landing/Custom/Zoom-Logo.svg" className='img-fluid' alt="" />
                                                </div>
                                            </>
                                        )}
                                    </label> */}
                </>
              );
            },
          },
          Align: {
            label: "Alignment",
            type: "select",
            options: [
              { label: "Left", value: "justify-content-start" },
              { label: "Center", value: "justify-content-center" },
              { label: "Right", value: "justify-content-end" },
            ],
          },

          link: {
            type: "custom",
            label: "Add link",
            render: ({ name, onChange, value, field }) => (
              <>
                <FieldLabel label={field.label}></FieldLabel>
                <input
                  type="text"
                  defaultValue={value}
                  name={name}
                  onChange={(e) => onChange(e.currentTarget.value)}
                />
              </>
            ),
          },
        },
        defaultProps: {
          logo: DAlogo,
        },
        render: ({ logo, link, Align }) => {
          return (
            <div className="landing-page-wrapper">
              <div className="header-section">
                <div className="container">
                  <div className={`logo-wrapper d-flex ${Align}`}>
                    <Link to={link}>
                      <img src={logo} alt="" />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          );
        },
      },
      HeaderTwoLogos: {
        fields: {
          logo1: {
            type: "custom",
            label: "Add image  (207 × 27 px)",
            render: ({ name, onChange, value, field }) => {
              return (
                <>
                  <FieldLabel label={field.label}></FieldLabel>
                  <input
                    type="file"
                    className="d-none"
                    id="uploadLogo"
                    name={name}
                  />
                  <label
                    htmlFor="uploadLogo"
                    className="icon-upload"
                    onClick={() => onChange("")}
                  >
                    {value ? (
                      <>
                        <button
                          className="remove-btn"
                          onClick={() => onChange("")}
                        >
                          <Svg name="remove-icn-roi" />
                        </button>
                        <div className={`img-wrapper ${value ? "" : "d-none"}`}>
                          <img src={value} className="img-fluid" alt="" />
                        </div>
                      </>
                    ) : (
                      <>
                        <Svg name="upload-icon" />
                        <span>Upload Image</span>
                        <div className={`img-wrapper ${value ? "" : "d-none"}`}>
                          <img
                            src="https://survey-bis.s3.ap-south-1.amazonaws.com/landing/Custom/Zoom-Logo.svg"
                            className="img-fluid"
                            alt=""
                          />
                        </div>
                      </>
                    )}
                  </label>
                </>
              );
            },
          },

          link1: {
            type: "custom",
            label: "Add link",
            render: ({ name, onChange, value, field }) => (
              <>
                <FieldLabel label={field.label}></FieldLabel>
                <input
                  type="text"
                  defaultValue={value}
                  name={name}
                  onChange={(e) => onChange(e.currentTarget.value)}
                />
              </>
            ),
          },
          logo2: {
            type: "custom",
            label: "Add image  (207 × 27 px)",
            render: ({ name, onChange, value, field }) => {
              return (
                <>
                  <FieldLabel label={field.label}></FieldLabel>
                  <input
                    type="file"
                    className="d-none"
                    id="uploadLogo2"
                    name={name}
                  />
                  <label
                    htmlFor="uploadLogo2"
                    className="icon-upload"
                    onClick={() => onChange("")}
                  >
                    {value ? (
                      <>
                        <button
                          className="remove-btn"
                          onClick={() => onChange("")}
                        >
                          <Svg name="remove-icn-roi" />
                        </button>
                        <div className={`img-wrapper ${value ? "" : "d-none"}`}>
                          <img src={value} className="img-fluid" alt="" />
                        </div>
                      </>
                    ) : (
                      <>
                        <Svg name="upload-icon" />
                        <span>Upload Image</span>
                        <div className={`img-wrapper ${value ? "" : "d-none"}`}>
                          <img
                            src="https://survey-bis.s3.ap-south-1.amazonaws.com/landing/Custom/Zoom-Logo.svg"
                            className="img-fluid"
                            alt=""
                          />
                        </div>
                      </>
                    )}
                  </label>
                </>
              );
            },
          },

          link2: {
            type: "custom",
            label: "Add link",
            render: ({ name, onChange, value, field }) => (
              <>
                <FieldLabel label={field.label}></FieldLabel>
                <input
                  type="text"
                  defaultValue={value}
                  name={name}
                  onChange={(e) => onChange(e.currentTarget.value)}
                />
              </>
            ),
          },
        },
        defaultProps: {
          logo1: DAlogo,
          logo2: DAlogo,
        },
        render: ({ logo1, link1, logo2, link2 }) => {
          return (
            <div className="landing-page-wrapper">
              <div className="header-section">
                <div className="container">
                  <div
                    className={`logo-wrapper d-flex justify-content-between align-items-center`}
                  >
                    <Link to={link1}>
                      <img src={logo1} alt="" />
                    </Link>
                    <Link to={link2}>
                      <img src={logo2} alt="" />
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          );
        },
      },
      LandingBannerLeftText: {
        render: ({
          Title,
          Description,
          buttonText,
          paddingTop,
          paddingBottom,
          image,
        }) => {
          const handleButtonClick = () => {
            // Navigate to TataComms login; after return with customToken we will auto-show the form
            window.location.replace(buildLoginUrl('EH_16'));
          };
          return (
            <>
              <div className="landing-page-wrapper">
                <div className="flex-grow-1 main-content-wrap">
                  <div
                    className={`landing-banner-section position-relative ${paddingBottom} ${paddingTop}`}
                  >
                    <div className="container">
                      <div className="row align-items-center ">
                        <div className="col-lg-6">
                          <div className="banner-text">
                            <h1
                              className={`heading text-uppercase ${Title.titleFont} ${Title.fontWeight}`}
                              style={{
                                textAlign: Title.titleAlign,
                              }}
                            >
                              {Title.title}{" "}
                              <span className="text-theme-primary">
                                {Title.surveyName}
                              </span>
                            </h1>

                            <div className="text-part">
                              {/* <p className={`${Description.descriptionFont} ${Description.fontWeight}`} style={{
                                                                textAlign: Description.descriptionAlign
                                                            }}>{Description.description}</p> */}
                              <div
                                className={`${Description.Font} ${Description.fontWeight}`}
                                style={{
                                  textAlign: Description.Align,
                                }}
                              >
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: Description.description,
                                  }}
                                />
                              </div>
                            </div>
                            <div className="button-wrap">
                              <button
                                className="btn btn-primary"
                                type="submit"
                                onClick={handleButtonClick}
                              >
                                {buttonText}
                              </button>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="img-wrapper">
                            <img src={image} className="img-fluid" alt="" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        },
      },
      LandingBannerLeftText2: {
        render: ({
          Title,
          Description,
          buttonText,
          paddingTop,
          paddingBottom,
          image,
          Subtitle,
        }) => {
          const handleButtonClick = () => {
            // Navigate to TataComms login; after return with customToken we will auto-show the form
            window.location.replace(buildLoginUrl('EH_16'));
          };
          return (
            <>
              <div className="landing-page-wrapper">
                <div className="flex-grow-1 main-content-wrap">
                  <div
                    className={`landing-banner-section position-relative ${paddingBottom} ${paddingTop}`}
                  >
                    <div className="container">
                      <div className="row align-items-center ">
                        <div className="col-lg-6">
                          <div className="banner-text">
                            <h1
                              className={`heading text-uppercase ${Title.titleFont} ${Title.fontWeight}`}
                              style={{
                                textAlign: Title.titleAlign,
                              }}
                            >
                              {Title.title}{" "}
                              <span className="text-theme-primary">
                                {Title.surveyName}
                              </span>
                            </h1>
                            <h3
                              className={`heading ${Subtitle.titleFont} ${Subtitle.fontWeight}`}
                              style={{
                                textAlign: Subtitle.titleAlign,
                              }}
                            >
                              <div
                                dangerouslySetInnerHTML={{
                                  __html: Subtitle.title,
                                }}
                              />
                            </h3>

                            <div className="text-part">
                              {/* <p className={`//${Description.descriptionFont} ${Description.fontWeight}`} style={{
                                                                textAlign: Description.descriptionAlign
                                                            }}>{Description.description}</p> */}
                              <div
                                className={`${Description.descriptionFont} ${Description.fontWeight}`}
                                style={{
                                  textAlign: Description.descriptionAlign,
                                }}
                              >
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: Description.description,
                                  }}
                                />
                              </div>
                            </div>

                            <div className="button-wrap">
                              <button
                                className="btn btn-primary"
                                type="submit"
                                onClick={handleButtonClick}
                              >
                                {buttonText}
                              </button>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="img-wrapper">
                            <img src={image} className="img-fluid" alt="" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        },
      },
      LandingContentRightText: {
        render: ({ Title, Description, paddingTop, paddingBottom, image }) => {
          return (
            <>
              <div className="landing-page-wrapper">
                <div className="flex-grow-1 main-content-wrap">
                  <div
                    className={`landing-content-section right-media ${paddingBottom} ${paddingTop}`}
                  >
                    <div className="container">
                      <div className="row justify-content-between align-items-center">
                        <div className="col-lg-6">
                          <div className="img-wrapper">
                            <img src={image} className="img-fluid" alt="" />
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="text-wrap ps-3">
                            <h2
                              className={`heading ${Title.Font} ${Title.fontWeight}`}
                              style={{
                                textAlign: Title.Align,
                              }}
                            >
                              {Title.title}
                            </h2>
                            <div className="text-part">
                              {/* <p className={`${Description.Font} ${Description.fontWeight}`} style={{
                                                                textAlign: Description.Align
                                                            }}>{Description.description}</p> */}
                              <div
                                className={`${Description.Font} ${Description.fontWeight}`}
                                style={{
                                  textAlign: Description.Align,
                                }}
                              >
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: Description.description,
                                  }}
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        },
      },

      LandingCTASection: {
        render: ({
          title,
          titleFont,
          fontWeight,
          buttonText,
          Align,
          paddingTop,
          paddingBottom,
          layout,
        }) => {
          const handleButtonClick = () => {
            // Navigate to TataComms login; after return with customToken we will auto-show the form
            window.location.replace(buildLoginUrl('EH_16'));
          };
          return (
            <>
              <div className="landing-page-wrapper">
                <div className="flex-grow-1 main-content-wrap">
                  {layout === "layout1" ? (
                    <div
                      className={`landing-cta-section no-media`}
                      style={{
                        textAlign: Align,
                      }}
                    >
                      <div className="container">
                        <div
                          className={`text-wrap ${paddingBottom} ${paddingTop}`}
                        >
                          <h3
                            className={`text-white heading ${fontWeight} ${titleFont}`}
                          >
                            {title}
                          </h3>
                          <div className="button-wrap">
                            <button
                              className="btn btn-white"
                              type="submit"
                              onClick={handleButtonClick}
                            >
                              {buttonText}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div
                      className={`landing-cta-alternate-section`}
                      style={{
                        textAlign: Align,
                      }}
                    >
                      <div className="container">
                        <div
                          className={`text-wrap ${paddingBottom} ${paddingTop}`}
                        >
                          <h3
                            className={`text-white heading ${fontWeight} ${titleFont}`}
                          >
                            {title}
                          </h3>
                          <div className="button-wrap">
                            <button
                              className="btn btn-white"
                              type="submit"
                              onClick={handleButtonClick}
                            >
                              {buttonText}
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </>
          );
        },
      },

      LandingAccordionSection: {
        render: ({
          Title,
          SubTitle,
          paddingTop,
          paddingBottom,
          items,
          image,
        }) => {
          return (
            <>
              <div className="landing-page-wrapper">
                <div className="flex-grow-1 main-content-wrap">
                  <div
                    className={`accordion-section ${paddingBottom} ${paddingTop}`}
                  >
                    <div className="container">
                      <div className="section-title text-center text-part">
                        <h2
                          className={`text-uppercase mb-1 ${Title.Font} ${Title.fontWeight}`}
                          style={{
                            textAlign: Title.Align,
                          }}
                        >
                          {Title.title}
                        </h2>
                        <p
                          className={`${SubTitle.Font} ${SubTitle.fontWeight}`}
                          style={{
                            textAlign: SubTitle.Align,
                          }}
                        >
                          {SubTitle.subtitle}
                        </p>
                      </div>
                      <div className="row">
                        <div className="col-lg-6">
                          <div className="accordion" id="accordionBenchmarking">
                            {items.map((item, i) => (
                              <div className="accordion-item" key={i}>
                                <h2
                                  className="accordion-header"
                                  id={`heading-${i}`}
                                >
                                  <button
                                    className={
                                      i === 0
                                        ? "accordion-button"
                                        : "accordion-button collapsed"
                                    }
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target={`#collapse-${i}`}
                                    aria-expanded="false"
                                    aria-controls={`collapse-${i}`}
                                  >
                                    {item.Title}
                                  </button>
                                </h2>
                                <div
                                  id={`collapse-${i}`}
                                  className={
                                    i === 0
                                      ? "accordion-collapse collapse show"
                                      : "accordion-collapse collapse"
                                  }
                                  aria-labelledby={`heading-${i}`}
                                  data-bs-parent="#accordionBenchmarking"
                                >
                                  <div className="accordion-body text-part">
                                    <p>{item.Description}</p>
                                  </div>
                                </div>
                              </div>
                            ))}
                          </div>
                        </div>
                        <div className="col-lg-5 offset-lg-1">
                          <div className="img-wrapper">
                            <img src={image} className="img-fluid" alt="" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        },
      },

      LandingTabsSection: {
        render: ({
          Title,
          SubTitle,
          paddingTop,
          paddingBottom,
          items,
          image,
        }) => {
          return (
            <>
              <div className="landing-page-wrapper">
                <div className="flex-grow-1 main-content-wrap">
                  <div
                    className={`section-padding-60 tabs-section ${paddingBottom} ${paddingTop}`}
                  >
                    <div className="container">
                      <div className="section-title text-center text-part position-relative">
                        <h2
                          className={`text-uppercase mb-1 ${Title.Font} ${Title.fontWeight}`}
                          style={{
                            textAlign: Title.Align,
                          }}
                        >
                          {Title.title}
                        </h2>
                        <p
                          className={`${SubTitle.Font} ${SubTitle.fontWeight}`}
                          style={{
                            textAlign: SubTitle.Align,
                          }}
                        >
                          {SubTitle.subtitle}
                        </p>
                      </div>
                      <div className="position-relative img-tab">
                        <div className="row tab-index">
                          <div className="col-lg-7">
                            <div className="tab-wrapper">
                              <ul
                                className="nav nav-tabs"
                                id="myTab"
                                role="tablist"
                              >
                                {items.map((item, i) => (
                                  <li
                                    className="nav-item"
                                    role="presentation"
                                    key={i}
                                  >
                                    <button
                                      className={
                                        i === 0 ? "nav-link active" : "nav-link"
                                      }
                                      id={`tab-${i}`}
                                      data-bs-toggle="tab"
                                      data-bs-target={`#tab-${i}-pane`}
                                      type="button"
                                      role="tab"
                                      aria-controls={`tab-${i}-pane`}
                                      aria-selected="false"
                                    >
                                      {item.Title}
                                    </button>
                                  </li>
                                ))}
                              </ul>
                              <div className="tab-content" id="myTabContent">
                                {items.map((item, i) => (
                                  <div
                                    className={
                                      i === 0
                                        ? "tab-pane fade show active"
                                        : "tab-pane fade"
                                    }
                                    id={`tab-${i}-pane`}
                                    role="tabpanel"
                                    aria-labelledby={`tab-${i}`}
                                    tabIndex={0}
                                  >
                                    <div className="accordion-body text-part">
                                      <p>{item.Description}</p>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="img-wrapper">
                          <img src={image} className="img-fluid" alt="" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        },
      },

      LandingFooter: {
        fields: {
          text: {
            type: "custom",
            label: "Title",
            render: ({ name, onChange, value, field }) => (
              <>
                <FieldLabel label={field.label}></FieldLabel>
                <input
                  defaultValue={value}
                  name={name}
                  onChange={(e) => onChange(e.currentTarget.value)}
                />
              </>
            ),
          },

          textFont: {
            label: "Title font size",
            type: "select",
            options: [
              { label: "22px", value: "fs-22" },
              { label: "18px", value: "fs-18" },
              { label: "16px", value: "fs-16" },
              { label: "14px", value: "fs-14" },
            ],
          },

          paddingTop: {
            label: "Footer Spacing from top",
            type: "select",
            options: [
              { label: "None", value: "pt-0" },
              { label: "Small", value: "pt-30" },
              { label: "Medium", value: "pt-60" },
              { label: "Large", value: "pt-90" },
            ],
          },

          paddingBottom: {
            label: "Footer Spacing from bottom",
            type: "select",
            options: [
              { label: "None", value: "pb-0" },
              { label: "Small", value: "pb-30" },
              { label: "Medium", value: "pb-60" },
              { label: "Large", value: "pb-90" },
            ],
          },
        },
        defaultProps: {
          text: "© 2024. All rights reserved.",
          textFont: "fs-14",
          paddingTop: "pt-30",
          paddingBottom: "pb-30",
        },
        render: ({ text, textFont, paddingTop, paddingBottom }) => {
          return (
            <>
              <div className="landing-page-wrapper">
                <div
                  className={`footer-section ${paddingBottom} ${paddingTop}`}
                >
                  <div className="container">
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="footer-logo-copyright">
                          <div className="copyright ps-0 text-center">
                            <p className={textFont}>{text}</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        },
      },

      //Report Pages
      ReportBanner: {
        fields: {
          Description: {
            type: "object",
            objectFields: {
              text: {
                type: "custom",
                label: "Text",
                render: ({ name, onChange, value, field }) => (
                  <>
                    <FieldLabel label={field.label}></FieldLabel>
                    <textarea
                      defaultValue={value}
                      className="form-control"
                      name={name}
                      onChange={(e) => onChange(e.currentTarget.value)}
                    />
                  </>
                ),
              },
              descriptionFont: {
                label: "Font size",
                type: "select",
                options: [
                  { label: "22px", value: "fs-22" },
                  { label: "18px", value: "fs-18" },
                  { label: "16px", value: "fs-16" },
                  { label: "14px", value: "fs-14" },
                ],
              },
            },
          },
          Heading: {
            type: "object",
            objectFields: {
              title: {
                type: "custom",
                label: "Title",
                render: ({ name, onChange, value, field }) => (
                  <>
                    <FieldLabel label={field.label}></FieldLabel>

                    <textarea
                      defaultValue={value}
                      className="form-control"
                      name={name}
                      onChange={(e) => onChange(e.currentTarget.value)}
                    />
                  </>
                ),
              },
              titleFont: {
                label: "Font size",
                type: "select",
                options: [
                  { label: "48px", value: "fs-48" },
                  { label: "50px", value: "fs-50" },
                  { label: "55px", value: "fs-55" },
                  { label: "60px", value: "fs-60" },
                  { label: "65px", value: "fs-65" },
                ],
              },
              fontWeight: {
                label: "Font weight",
                type: "select",
                options: [
                  { label: "Regular", value: "fw-400" },
                  { label: "Medium", value: "fw-500" },
                  { label: "Semi-Bold", value: "fw-600" },
                  { label: "Bold", value: "fw-700" },
                ],
              },
            },
          },

          image: {
            type: "custom",
            label: "Add image +1",
            render: ({ name, onChange, value, field }) => (
              <>
                <FieldLabel label={field.label}></FieldLabel>

                <input
                  type="file"
                  id="uploadImage"
                  className="d-none"
                  // defaultValue={value}
                  name={name}
                  onChange={(e) => onChange(e.currentTarget.value)}
                />
                <label htmlFor="uploadImage" className="icon-upload">
                  {/**Render remove button when icon is uploaded**/}
                  <button className="remove-btn">
                    <Svg name="remove-icn-roi" />
                  </button>
                  <div className="img-wrapper">
                    <img
                      src="https://survey-bis.s3.ap-south-1.amazonaws.com/landing/Hero/Hero-1.png"
                      className="img-fluid"
                      alt=""
                    />
                  </div>
                </label>
              </>
            ),
          },
          logo: {
            type: "custom",
            label: "Add logo",
            render: ({ name, onChange, value, field }) => (
              <>
                <FieldLabel label={field.label}></FieldLabel>

                <input
                  type="file"
                  id="uploadImage"
                  className="d-none"
                  // defaultValue={value}
                  name={name}
                  onChange={(e) => onChange(e.currentTarget.value)}
                />
                <label htmlFor="uploadImage" className="icon-upload">
                  {/**Render remove button when icon is uploaded**/}
                  <button className="remove-btn">
                    <Svg name="remove-icn-roi" />
                  </button>
                  <div className="img-wrapper">
                    <img
                      src="https://survey-bis.s3.ap-south-1.amazonaws.com/logo/1.svg"
                      className="img-fluid logo contain"
                      alt=""
                    />
                  </div>
                </label>
              </>
            ),
          },
        },
        defaultProps: {
          Heading: {
            title:
              "<span class='text-theme-primary'>Abhimanyu Sankhyan</span>, your company <span class='text-theme-primary'>Test Company LLC</span> is at <span class='text-theme-primary'>'Advanced'</span> stage",
            fontWeight: "fw-700",
            titleFont: "fs-60",
          },

          Description: {
            text: "Threat Hunting Assessment",
            descriptionFont: "fs-18",
          },

          image:
            "https://survey-bis.s3.ap-south-1.amazonaws.com/reportImg/Images/Banner/Image-2.png",
          logo: "https://survey-bis.s3.ap-south-1.amazonaws.com/logo/1.svg",
        },
        render: ({ Heading, Description, image, logo }) => {
          return (
            <>
              <div
                className="report-banner report-build-wrapper d-flex align-items-end justify-content-end"
                style={{ backgroundImage: `url("${image}")` }}
              >
                <div className="container">
                  <div className="text wrapper">
                    <p className={Description.descriptionFont}>
                      {Description.text}
                    </p>
                    <h1
                      className={`${Heading.fontWeight} ${Heading.titleFont}`}
                    >
                      <div
                        dangerouslySetInnerHTML={{ __html: Heading.title }}
                      />
                    </h1>
                  </div>
                </div>
                <div className="report-footer-logo">
                  <div className="container">
                    <div className="logo-wrap">
                      <img src={logo} alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        },
      },

      ReportWhatsInside: {
        fields: {
          Heading: {
            type: "object",
            objectFields: {
              title: {
                type: "custom",
                label: "Title",
                render: ({ name, onChange, value, field }) => (
                  <>
                    <FieldLabel label={field.label}></FieldLabel>

                    <textarea
                      defaultValue={value}
                      className="form-control"
                      name={name}
                      onChange={(e) => onChange(e.currentTarget.value)}
                    />
                  </>
                ),
              },
              titleFont: {
                label: "Font size",
                type: "select",
                options: [
                  { label: "45px", value: "fs-45" },
                  { label: "48px", value: "fs-48" },
                  { label: "50px", value: "fs-50" },
                  { label: "55px", value: "fs-55" },
                  { label: "60px", value: "fs-60" },
                ],
              },
              fontWeight: {
                label: "Font weight",
                type: "select",
                options: [
                  { label: "Regular", value: "fw-400" },
                  { label: "Medium", value: "fw-500" },
                  { label: "Semi-Bold", value: "fw-600" },
                  { label: "Bold", value: "fw-700" },
                ],
              },
            },
          },

          items: {
            type: "array",
            label: "Sections",
            arrayFields: {
              Title: { type: "text" },
              CouterFontSize: {
                label: "Counter font size",
                type: "select",
                options: [
                  { label: "100px", value: "fs-100" },
                  { label: "80px", value: "fs-80" },
                  { label: "60px", value: "fs-60" },
                  { label: "50px", value: "fs-50" },
                  { label: "40px", value: "fs-40" },
                ],
              },
              CounterFontWeight: {
                label: "Counter font weight",
                type: "select",
                options: [
                  { label: "Regular", value: "fw-400" },
                  { label: "Medium", value: "fw-500" },
                  { label: "Semi-Bold", value: "fw-600" },
                  { label: "Bold", value: "fw-700" },
                ],
              },
              TitleFontSize: {
                label: "Title font size",
                type: "select",
                options: [
                  { label: "20px", value: "fs-20" },
                  { label: "18px", value: "fs-18" },
                  { label: "16px", value: "fs-16" },
                  { label: "14px", value: "fs-14" },
                ],
              },
            },
            getItemSummary: (item) => item.Title || "Section",
            defaultItemProps: {
              Title: "Section title",
              CouterFontSize: "fs-100",
              CounterFontWeight: "fw-400",
              TitleFontSize: "fs-20",
            },
          },

          logo: {
            type: "custom",
            label: "Add logo",
            render: ({ name, onChange, value, field }) => (
              <>
                <FieldLabel label={field.label}></FieldLabel>

                <input
                  type="file"
                  id="uploadImage"
                  className="d-none"
                  // defaultValue={value}
                  name={name}
                  onChange={(e) => onChange(e.currentTarget.value)}
                />
                <label htmlFor="uploadImage" className="icon-upload">
                  {/**Render remove button when icon is uploaded**/}
                  <button className="remove-btn">
                    <Svg name="remove-icn-roi" />
                  </button>
                  <div className="img-wrapper">
                    <img
                      src="https://survey-bis.s3.ap-south-1.amazonaws.com/logo/1.svg"
                      className="img-fluid logo contain"
                      alt=""
                    />
                  </div>
                </label>
              </>
            ),
          },
        },
        defaultProps: {
          Heading: {
            title: "What's Inside",
            fontWeight: "fw-700",
            CounterFontWeight: "fw-400",
            titleFont: "fs-45",
          },

          items: [
            {
              Title: "Introduction",
              CouterFontSize: "fs-100",
              CounterFontWeight: "fw-400",
              TitleFontSize: "fs-20",
            },
            {
              Title: "Methodology",
              CouterFontSize: "fs-100",
              CounterFontWeight: "fw-400",
              TitleFontSize: "fs-20",
            },
            {
              Title: "Test Company LLC assessment and recommendations",
              CouterFontSize: "fs-100",
              CounterFontWeight: "fw-400",
              TitleFontSize: "fs-20",
            },
            {
              Title: "Test Company LLC Threat Hunting Services",
              CouterFontSize: "fs-100",
              CounterFontWeight: "fw-400",
              TitleFontSize: "fs-20",
            },
            {
              Title: "Your responses to the assessment",
              CouterFontSize: "fs-100",
              CounterFontWeight: "fw-400",
              TitleFontSize: "fs-20",
            },
          ],

          logo: "https://survey-bis.s3.ap-south-1.amazonaws.com/logo/1.svg",
        },
        render: ({ Heading, logo, items }) => {
          return (
            <>
              <div className="report-whats-inside report-build-wrapper">
                <div className="container">
                  <div className="text wrapper">
                    <div className="rep-heading">
                      <h2
                        className={`${Heading.fontWeight} ${Heading.titleFont}`}
                      >
                        {Heading.title}
                      </h2>
                    </div>
                    <div className="inside-main">
                      <div className="row">
                        {items.map((item, i) => (
                          <div className="col-lg-4 col-md-4" key={i}>
                            <div className="inside-wrapper">
                              <h4
                                className={`${item.CouterFontSize} ${item.CounterFontWeight}`}
                              >
                                {String(i + 1).padStart(2, "0")}
                              </h4>
                              <p className={`${item.TitleFontSize}`}>
                                {item.Title}
                              </p>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="report-footer-logo">
                  <div className="container">
                    <div className="logo-wrap">
                      <img src={logo} alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        },
      },

      ReportMethodology: {
        fields: {
          Heading: {
            type: "object",
            objectFields: {
              title: {
                type: "custom",
                label: "Title",
                render: ({ name, onChange, value, field }) => (
                  <>
                    <FieldLabel label={field.label}></FieldLabel>

                    <textarea
                      defaultValue={value}
                      className="form-control"
                      name={name}
                      onChange={(e) => onChange(e.currentTarget.value)}
                    />
                  </>
                ),
              },
              titleFont: {
                label: "Font size",
                type: "select",
                options: [
                  { label: "45px", value: "fs-45" },
                  { label: "48px", value: "fs-48" },
                  { label: "50px", value: "fs-50" },
                  { label: "55px", value: "fs-55" },
                  { label: "60px", value: "fs-60" },
                ],
              },
              fontWeight: {
                label: "Font weight",
                type: "select",
                options: [
                  { label: "Regular", value: "fw-400" },
                  { label: "Medium", value: "fw-500" },
                  { label: "Semi-Bold", value: "fw-600" },
                  { label: "Bold", value: "fw-700" },
                ],
              },
            },
          },

          Text: {
            type: "object",
            objectFields: {
              title: {
                type: "custom",
                label: "Title",
                render: ({ name, onChange, value, field }) => (
                  <>
                    <FieldLabel label={field.label}></FieldLabel>
                    <textarea
                      defaultValue={value}
                      className="form-control"
                      name={name}
                      onChange={(e) => onChange(e.currentTarget.value)}
                    />
                  </>
                ),
              },
              TitleFont: {
                label: "Font size",
                type: "select",
                options: [
                  { label: "22px", value: "fs-22" },
                  { label: "20px", value: "fs-20" },
                  { label: "18px", value: "fs-18" },
                  { label: "16px", value: "fs-16" },
                  { label: "14px", value: "fs-14" },
                ],
              },
              fontWeight: {
                label: "Font weight",
                type: "select",
                options: [
                  { label: "Regular", value: "fw-400" },
                  { label: "Medium", value: "fw-500" },
                  { label: "Semi-Bold", value: "fw-600" },
                  { label: "Bold", value: "fw-700" },
                ],
              },

              description: {
                type: "custom",
                label: "Text",
                render: ({ name, onChange, value, field }) => (
                  <>
                    <FieldLabel label={field.label}></FieldLabel>
                    <textarea
                      defaultValue={value}
                      className="form-control"
                      name={name}
                      onChange={(e) => onChange(e.currentTarget.value)}
                    />
                  </>
                ),
              },
              descriptionFont: {
                label: "Font size",
                type: "select",
                options: [
                  { label: "18px", value: "fs-18" },
                  { label: "16px", value: "fs-16" },
                  { label: "15px", value: "fs-15" },
                  { label: "14px", value: "fs-14" },
                ],
              },
            },
          },

          items: {
            type: "array",
            label: "Sections",
            arrayFields: {
              Title: { type: "text" },
              TitleFontSize: {
                label: "Title font size",
                type: "select",
                options: [
                  { label: "22px", value: "fs-22" },
                  { label: "20px", value: "fs-20" },
                  { label: "18px", value: "fs-18" },
                  { label: "16px", value: "fs-16" },
                  { label: "14px", value: "fs-14" },
                ],
              },
              TitleFontWeight: {
                label: "Title font weight",
                type: "select",
                options: [
                  { label: "Regular", value: "fw-400" },
                  { label: "Medium", value: "fw-500" },
                  { label: "Semi-Bold", value: "fw-600" },
                  { label: "Bold", value: "fw-700" },
                ],
              },
              Description: { type: "textarea" },
              DescriptionFontSize: {
                label: "Description font size",
                type: "select",
                options: [
                  { label: "18px", value: "fs-18" },
                  { label: "16px", value: "fs-16" },
                  { label: "15px", value: "fs-15" },
                  { label: "14px", value: "fs-14" },
                ],
              },
            },
            getItemSummary: (item) => item.Title || "Section",
            defaultItemProps: {
              Title: "Section title",
              TitleFontSize: "fs-16",
              TitleFontWeight: "fw-700",
              Description: "Section description",
              DescriptionFontSize: "fs-15",
            },
          },
          image: {
            type: "custom",
            label: "Add image +2",
            render: ({ name, onChange, value, field }) => (
              <>
                <FieldLabel label={field.label}></FieldLabel>

                <input
                  type="file"
                  id="uploadImage"
                  className="d-none"
                  // defaultValue={value}
                  name={name}
                  onChange={(e) => onChange(e.currentTarget.value)}
                />
                <label htmlFor="uploadImage" className="icon-upload">
                  {/**Render remove button when icon is uploaded**/}
                  <button className="remove-btn">
                    <Svg name="remove-icn-roi" />
                  </button>
                  <div className="img-wrapper">
                    <img
                      src="https://survey-bis.s3.ap-south-1.amazonaws.com/landing/Hero/Hero-1.png"
                      className="img-fluid"
                      alt=""
                    />
                  </div>
                </label>
              </>
            ),
          },

          logo: {
            type: "custom",
            label: "Add logo",
            render: ({ name, onChange, value, field }) => (
              <>
                <FieldLabel label={field.label}></FieldLabel>

                <input
                  type="file"
                  id="uploadImage"
                  className="d-none"
                  // defaultValue={value}
                  name={name}
                  onChange={(e) => onChange(e.currentTarget.value)}
                />
                <label htmlFor="uploadImage" className="icon-upload">
                  {/**Render remove button when icon is uploaded**/}
                  <button className="remove-btn">
                    <Svg name="remove-icn-roi" />
                  </button>
                  <div className="img-wrapper">
                    <img
                      src="https://survey-bis.s3.ap-south-1.amazonaws.com/logo/1.svg"
                      className="img-fluid logo contain"
                      alt=""
                    />
                  </div>
                </label>
              </>
            ),
          },
        },
        defaultProps: {
          Heading: {
            title: "02 Methodology",
            fontWeight: "fw-700",
            titleFont: "fs-60",
          },
          Text: {
            title: "Lead Indicators",
            TitleFont: "fs-20",
            fontWeight: "fw-700",
            description:
              "Assessing enterprise threat hunting readiness, this framework scrutinizes technology integration, expertise, intelligence usage, resource allocation, and incident response to elevate security posture.",
            descriptionFont: "fs-15",
          },
          items: [
            {
              Title: "Technology Integration",
              TitleFontSize: "fs-16",
              TitleFontWeight: "fw-700",
              DescriptionFontSize: "fs-15",
              Description:
                "Technology Integration evaluates an enterprise's adoption of advanced tools for threat hunting, including machine learning and cloud-based defenses.",
            },
            {
              Title: "Skills and Expertise",
              TitleFontSize: "fs-16",
              TitleFontWeight: "fw-700",
              DescriptionFontSize: "fs-15",
              Description:
                "Skills and Expertise gauge staff proficiency in threat identification, emphasizing agility in handling security data and attack methods.",
            },
            {
              Title: "Threat Intelligence Utilization",
              TitleFontSize: "fs-16",
              TitleFontWeight: "fw-700",
              DescriptionFontSize: "fs-15",
              Description:
                "Threat Intelligence Utilization reviews how organizations proactively leverage intelligence to confront evolving threats and IT complexities.",
            },
            {
              Title: "Budget and Resource Allocation",
              TitleFontSize: "fs-16",
              TitleFontWeight: "fw-700",
              DescriptionFontSize: "fs-15",
              Description:
                "Budget and Resource Allocation assesses funding and asset distribution, prioritizing specialized tools and training for threat hunting efficacy.",
            },
            {
              Title: "Incident Response and Coordination",
              TitleFontSize: "fs-16",
              TitleFontWeight: "fw-700",
              DescriptionFontSize: "fs-15",
              Description:
                "Incident Response and Coordination examines procedural efficiency post-threat detection, focusing on automation and adaptability.",
            },
          ],

          image:
            "https://survey-bis.s3.ap-south-1.amazonaws.com/reportImg/Images/InnerPages/image-12.png",
          logo: "https://survey-bis.s3.ap-south-1.amazonaws.com/logo/1.svg",
        },
        render: ({ Heading, logo, image, items, Text }) => {
          return (
            <>
              <div className="report-build-wrapper report-right-image-section">
                <div className="text wrapper flex-grow-1">
                  <div className="rep-heading-page">
                    <h2
                      className={`${Heading.fontWeight} ${Heading.titleFont}`}
                    >
                      {Heading.title}
                    </h2>
                  </div>

                  <div className="text-part">
                    <div className="report-text mb__20">
                      <h4 className={`${Text.fontWeight} ${Text.TitleFont}`}>
                        {Text.title}
                      </h4>
                      <p className={`${Text.descriptionFont}`}>
                        {Text.description}
                      </p>
                    </div>
                    <div className="list-text report-text row">
                      {items.map((item, i) => (
                        <div className="col-md-6" key={i}>
                          <div className="list-wrap mb__20">
                            <h6
                              className={`${item.TitleFontSize} ${item.TitleFontWeight}`}
                            >
                              {item.Title}
                            </h6>
                            <p className={`${item.DescriptionFontSize}`}>
                              {item.Description}
                            </p>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
                <div
                  className="image-part"
                  style={{ backgroundImage: `url("${image}")` }}
                ></div>

                <div className="report-footer-logo">
                  <div className="container">
                    <div className="logo-wrap">
                      <img src={logo} alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        },
      },

      ReportStages: {
        fields: {
          Heading: {
            type: "object",
            objectFields: {
              title: {
                type: "custom",
                label: "Title",
                render: ({ name, onChange, value, field }) => (
                  <>
                    <FieldLabel label={field.label}></FieldLabel>

                    <textarea
                      defaultValue={value}
                      className="form-control"
                      name={name}
                      onChange={(e) => onChange(e.currentTarget.value)}
                    />
                  </>
                ),
              },
              titleFont: {
                label: "Font size",
                type: "select",
                options: [
                  { label: "45px", value: "fs-45" },
                  { label: "48px", value: "fs-48" },
                  { label: "50px", value: "fs-50" },
                  { label: "55px", value: "fs-55" },
                  { label: "60px", value: "fs-60" },
                ],
              },
              fontWeight: {
                label: "Font weight",
                type: "select",
                options: [
                  { label: "Regular", value: "fw-400" },
                  { label: "Medium", value: "fw-500" },
                  { label: "Semi-Bold", value: "fw-600" },
                  { label: "Bold", value: "fw-700" },
                ],
              },
            },
          },

          Text: {
            type: "object",
            objectFields: {
              title: {
                type: "custom",
                label: "Title",
                render: ({ name, onChange, value, field }) => (
                  <>
                    <FieldLabel label={field.label}></FieldLabel>
                    <textarea
                      defaultValue={value}
                      className="form-control"
                      name={name}
                      onChange={(e) => onChange(e.currentTarget.value)}
                    />
                  </>
                ),
              },
              TitleFont: {
                label: "Font size",
                type: "select",
                options: [
                  { label: "22px", value: "fs-22" },
                  { label: "20px", value: "fs-20" },
                  { label: "18px", value: "fs-18" },
                  { label: "16px", value: "fs-16" },
                  { label: "14px", value: "fs-14" },
                ],
              },
              fontWeight: {
                label: "Font weight",
                type: "select",
                options: [
                  { label: "Regular", value: "fw-400" },
                  { label: "Medium", value: "fw-500" },
                  { label: "Semi-Bold", value: "fw-600" },
                  { label: "Bold", value: "fw-700" },
                ],
              },

              description: {
                type: "custom",
                label: "Text",
                render: ({ name, onChange, value, field }) => (
                  <>
                    <FieldLabel label={field.label}></FieldLabel>
                    <textarea
                      defaultValue={value}
                      className="form-control"
                      name={name}
                      onChange={(e) => onChange(e.currentTarget.value)}
                    />
                  </>
                ),
              },
              descriptionFont: {
                label: "Font size",
                type: "select",
                options: [
                  { label: "18px", value: "fs-18" },
                  { label: "16px", value: "fs-16" },
                  { label: "15px", value: "fs-15" },
                  { label: "14px", value: "fs-14" },
                ],
              },
            },
          },

          items: {
            type: "array",
            label: "Sections",
            arrayFields: {
              Title: { type: "text" },
              TitleFontSize: {
                label: "Title Font",
                type: "select",
                options: [
                  { label: "22px", value: "fs-22" },
                  { label: "20px", value: "fs-20" },
                  { label: "18px", value: "fs-18" },
                  { label: "16px", value: "fs-16" },
                  { label: "14px", value: "fs-14" },
                ],
              },
              TitleFontWeight: {
                label: "Font weight",
                type: "select",
                options: [
                  { label: "Regular", value: "fw-400" },
                  { label: "Medium", value: "fw-500" },
                  { label: "Semi-Bold", value: "fw-600" },
                  { label: "Bold", value: "fw-700" },
                ],
              },
              Description: { type: "textarea" },
              DescriptionFontSize: {
                label: "Title Font",
                type: "select",
                options: [
                  { label: "22px", value: "fs-22" },
                  { label: "20px", value: "fs-20" },
                  { label: "18px", value: "fs-18" },
                  { label: "16px", value: "fs-16" },
                  { label: "14px", value: "fs-14" },
                ],
              },
            },
            getItemSummary: (item) => item.Title || "Section",
            defaultItemProps: {
              Title: "Section title",
              TitleFontSize: "fs-22",
              TitleFontWeight: "fw-700",
              Description: "Section description",
              DescriptionFontSize: "fs-15",
            },
          },

          logo: {
            type: "custom",
            label: "Add logo",
            render: ({ name, onChange, value, field }) => (
              <>
                <FieldLabel label={field.label}></FieldLabel>

                <input
                  type="file"
                  id="uploadImage"
                  className="d-none"
                  // defaultValue={value}
                  name={name}
                  onChange={(e) => onChange(e.currentTarget.value)}
                />
                <label htmlFor="uploadImage" className="icon-upload">
                  {/**Render remove button when icon is uploaded**/}
                  <button className="remove-btn">
                    <Svg name="remove-icn-roi" />
                  </button>
                  <div className="img-wrapper">
                    <img
                      src="https://survey-bis.s3.ap-south-1.amazonaws.com/logo/1.svg"
                      className="img-fluid logo contain"
                      alt=""
                    />
                  </div>
                </label>
              </>
            ),
          },
        },
        defaultProps: {
          Heading: {
            title: "02 Methodology",
            fontWeight: "fw-700",
            titleFont: "fs-60",
          },
          Text: {
            title: "Readiness Stage",
            TitleFont: "fs-20",
            fontWeight: "fw-700",
            description:
              "At Tata Communications, the 'Readiness Stage' in the Enterprise Threat Hunting Maturity Assessment signifies the degree of an organization's preparedness in identifying and mitigating cyber threats. Each stage delineates the maturity and sophistication of processes, from nascent awareness to proactive, strategic operations.",
            descriptionFont: "fs-15",
          },
          items: [
            {
              Title: "Novice",
              TitleFontSize: "fs-22",
              TitleFontWeight: "fw-700",
              DescriptionFontSize: "fs-15",

              Description:
                "Novice entities may lack experience with threat hunting, employing reactive defense strategies and demonstrating minimal machine learning use. Their incident response may be uncoordinated with outdated tools, and threat intelligence might be underutilized, thereby necessitating foundational progress in skills and resource allocation.",
            },
            {
              Title: "Emerging",
              TitleFontSize: "fs-22",
              TitleFontWeight: "fw-700",
              DescriptionFontSize: "fs-15",
              Description:
                "Emerging organizations are developing their threat hunting processes. They experiment with machine learning, share intelligence within communities, and utilize cloud tools for key functions. Staff have a good understanding of techniques and threat data is managed systematically, despite some reliance on manual reviews.",
            },
            {
              Title: "Competent",
              TitleFontSize: "fs-22",
              TitleFontWeight: "fw-700",
              DescriptionFontSize: "fs-15",
              Description:
                "Firms in this bracket have a structured approach to threat hunting with regular proactive exercises and strategic threat intelligence utilization. They're skilled in adapting to evolving threats and complex IT environments, with established incident response coordination and investments in specialized tools and training. ",
            },
            {
              Title: "Advanced",
              TitleFontSize: "fs-22",
              TitleFontWeight: "fw-700",
              DescriptionFontSize: "fs-15",
              Description:
                "Organizations at this stage exhibit a high level of threat hunting maturity with fully integrated machine learning and cloud-based tools. They have expert teams leading in new methods and effectively handling vast security data, while also maintaining compliance and leveraging advanced analytics to minimize manual workload.",
            },
          ],

          logo: "https://survey-bis.s3.ap-south-1.amazonaws.com/logo/1.svg",
        },
        render: ({ Heading, logo, items, Text }) => {
          return (
            <>
              <div className="report-build-wrapper report-stages-section">
                <div className="container">
                  <div className="text wrapper">
                    <div className="rep-heading-page">
                      <h2
                        className={`${Heading.fontWeight} ${Heading.titleFont}`}
                      >
                        {Heading.title}
                      </h2>
                    </div>
                    <div className="text-part mb__20">
                      <div className="report-text">
                        <h4 className={`${Text.fontWeight} ${Text.TitleFont}`}>
                          {Text.title}
                        </h4>
                        <p className={`${Text.descriptionFont}`}>
                          {Text.description}
                        </p>
                      </div>
                    </div>
                    <div className="stages-name row">
                      {items.map((item, i) => (
                        <div className="col-lg-3 col-md-6 mb__20" key={i}>
                          <div className="stage-wrap">
                            <div className="name">
                              <h4
                                className={`${item.TitleFontSize} ${item.TitleFontWeight}`}
                              >
                                {item.Title}
                              </h4>
                            </div>
                            <div
                              className={`stage-description ${item.DescriptionFontSize}`}
                            >
                              {item.Description}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
                <div className="report-footer-logo">
                  <div className="container">
                    <div className="logo-wrap">
                      <img src={logo} alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        },
      },

      /**Custom Component**/
      Section: {
        render: ({ Padding, Style, Class }) => {
          return (
            <>
              <div
                className={`component-section ${Class} ${Padding.bottom} ${
                  Padding.top
                } ${Padding.fullHeight && "full-height"}`}
                style={{
                  backgroundImage: `url("${Style.Background}")`,
                  backgroundColor: `${Style.BackgroundColor}`,
                  backgroundPosition: "center",
                  backgroundSize: "cover",
                }}
              >
                {/* <div className='overlay'></div> */}
                <div className={`${Style.Width} position-relative`}>
                  <DropZone zone="section" />
                </div>
              </div>
            </>
          );
        },
      },

      Columns: {
        render: ({
          columns,
          distribution,
          vertical,
          gap,
          Padding,
          Style,
          Border,
        }) => {
          return (
            <div
              className={`d-grid section-column ${vertical}`}
              style={{
                backgroundImage: `url("${Style?.Background}`,
                backgroundColor: `${Style?.BackgroundColor}`,
                backgroundPosition: "center",
                backgroundSize: "cover",
                padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,

                borderStyle: Border?.BorderStyle,
                borderColor: Border?.BorderColor,
                borderWidth: `${Border?.BorderWidth?.top}px ${Border?.BorderWidth?.right}px ${Border?.BorderWidth?.bottom}px ${Border?.BorderWidth?.left}px`,
                borderRadius: `${Border?.BorderRadius}px`,

                gridTemplateColumns:
                  distribution === "manual"
                    ? "repeat(12, 1fr)"
                    : `repeat(${columns.length}, 1fr)`,
                gridColumnGap: `${gap}px`,
              }}
            >
              {columns.map(({ span, backgroundColor }, idx) => (
                <div
                  key={idx}
                  className="w-100"
                  style={{
                    display: "flex",
                    backgroundColor: backgroundColor,
                    flexDirection: "column",
                    gridColumn:
                      span && distribution === "manual"
                        ? `span ${Math.max(Math.min(span, 12), 1)}`
                        : "",
                  }}
                >
                  <DropZone
                    zone={`column-${idx}`}
                    // disallow={["Section"]}
                  />
                </div>
              ))}
            </div>
          );
        },
      },

      Wrapper: {
        render: ({ Padding, Style, Border, Class }) => {
          return (
            <>
              <div
                className={`component-wrapper ${Class}`}
                style={{
                  backgroundImage: `url("${Style.Background}")`,
                  backgroundColor: `${Style.BackgroundColor}`,
                  backgroundPosition: "center",
                  backgroundSize: "cover",
                  padding: `${Padding.top}px ${Padding.right}px ${Padding.bottom}px ${Padding.left}px`,

                  borderStyle: Border.BorderStyle,
                  borderColor: Border.BorderColor,
                  borderWidth: `${Border.BorderWidthTop}px ${Border.BorderWidthRight}px ${Border.BorderWidthBottom}px ${Border.BorderWidthLeft}px `,
                  borderRadius: `${Border.BorderRadius}px`,
                }}
              >
                {/* <div className='overlay'></div> */}
                <div className={`position-relative`}>
                  <DropZone zone="wrapper" />
                </div>
              </div>
            </>
          );
        },
      },

      Spacing: {
        render: ({ Height }) => {
          return (
            <div
              className="spacing-component"
              style={{ height: `${Height}` }}
            ></div>
          );
        },
      },

      Heading: {
        render: ({ Text, Padding }) => {
          return (
            <>
              {(() => {
                if (Text?.tag === "h1") {
                  return (
                    <h1
                      className={`section-title m-0 size-h1 ${Text?.fontWeight} ${Text?.titleFont}`}
                      style={{
                        color: `${Text?.Color}`,
                        textAlign: Text?.Align,
                        padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,
                      }}
                    >
                      <div
                        dangerouslySetInnerHTML={{ __html: Text?.title }}
                      ></div>
                    </h1>
                  );
                } else if (Text.tag === "h2") {
                  return (
                    <h2
                      className={`section-title m-0 size-h2 ${Text?.fontWeight} ${Text?.titleFont}`}
                      style={{
                        color: `${Text?.Color}`,
                        textAlign: Text?.Align,
                        padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,
                      }}
                    >
                      <div
                        dangerouslySetInnerHTML={{ __html: Text?.title }}
                      ></div>
                    </h2>
                  );
                } else if (Text.tag === "h3") {
                  return (
                    <h3
                      className={`section-title m-0 size-h2 ${Text?.fontWeight} ${Text?.titleFont}`}
                      style={{
                        color: `${Text?.Color}`,
                        textAlign: Text?.Align,
                        padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,
                      }}
                    >
                      <div
                        dangerouslySetInnerHTML={{ __html: Text?.title }}
                      ></div>
                    </h3>
                  );
                } else if (Text.tag === "h4") {
                  return (
                    <h4
                      className={`section-title m-0 size-h2 ${Text?.fontWeight} ${Text?.titleFont}`}
                      style={{
                        color: `${Text?.Color}`,
                        textAlign: Text?.Align,
                        padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,
                      }}
                    >
                      <div
                        dangerouslySetInnerHTML={{ __html: Text?.title }}
                      ></div>
                    </h4>
                  );
                } else if (Text.tag === "h5") {
                  return (
                    <h5
                      className={`section-title m-0 size-h2 ${Text?.fontWeight} ${Text?.titleFont}`}
                      style={{
                        color: `${Text?.Color}`,
                        textAlign: Text?.Align,
                        padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,
                      }}
                    >
                      <div
                        dangerouslySetInnerHTML={{ __html: Text?.title }}
                      ></div>
                    </h5>
                  );
                } else if (Text.tag === "h6") {
                  return (
                    <h6
                      className={`section-title m-0 size-h2 ${Text?.fontWeight} ${Text?.titleFont}`}
                      style={{
                        color: `${Text?.Color}`,
                        textAlign: Text?.Align,
                        padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,
                      }}
                    >
                      <div
                        dangerouslySetInnerHTML={{ __html: Text?.title }}
                      ></div>
                    </h6>
                  );
                }
              })()}
            </>
          );
        },
      },

      Text: {
        render: ({ Text }) => {
          return (
            <>
              <div
                style={{
                  color: `${Text.Color}`,
                  textAlign: Text.Align,
                }}
                className={`section-text m-0 ${Text.FontWeight} ${Text.FontSize}`}
                dangerouslySetInnerHTML={{ __html: Text.text }}
              ></div>
            </>
          );
        },
      },

      Image: {
        render: ({ Image, AspectRatio }) => {
          return (
            <>
              <div className="image-wrapper">
                <img
                  src={Image}
                  alt=""
                  className="img-fluid object-cover w-100"
                  style={{ aspectRatio: `${AspectRatio}` }}
                />
              </div>
            </>
          );
        },
      },
      TabsSection: {
        render: ({ Settings, items }) => {
          return (
            <>
              <div className="tabs-comp tab-wrapper">
                <ul
                  className="nav nav-tabs"
                  style={{ gap: `${Settings?.ItemsGap}px` }}
                  id="myTab"
                  role="tablist"
                >
                  {items.map((item, i) => (
                    <li className="nav-item" role="presentation" key={i}>
                      <button
                        className={
                          i === 0
                            ? `nav-link active ${Settings.Text.TitleFont}`
                            : `nav-link ${Settings.Text.TitleFont} ${Settings?.Text?.TitleFontWeight}`
                        }
                        id={`tab-${i}`}
                        data-bs-toggle="tab"
                        data-bs-target={`#tab-${i}-pane`}
                        type="button"
                        role="tab"
                        aria-controls={`tab-${i}-pane`}
                        aria-selected="false"
                        style={{ color: Settings?.Text?.TitleColor }}
                      >
                        {item.Title}
                      </button>
                    </li>
                  ))}
                </ul>
                <div className="tab-content" id="myTabContent">
                  {items.map((item, i) => (
                    <div
                      className={
                        i === 0 ? "tab-pane fade show active" : "tab-pane fade"
                      }
                      id={`tab-${i}-pane`}
                      role="tabpanel"
                      aria-labelledby={`tab-${i}`}
                      tabIndex={0}
                    >
                      <div className="accordion-body text-part p-0">
                        <div
                          className={`${Settings?.Text?.DescriptionFont} ${Settings?.Text?.DescriptionFontWeight} mb-0`}
                          style={{ color: Settings?.Text?.DescriptionColor }}
                        >
                          <div
                            dangerouslySetInnerHTML={{
                              __html: item?.Description,
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </>
          );
        },
      },

      AccordionSection: {
        render: ({ Settings, items }) => {
          return (
            <>
              <div
                className="accordion accordion-component"
                id="accordionComponent"
              >
                {items.map((item, i) => (
                  <div className="accordion-item" key={i}>
                    <h2 className="accordion-header" id={`heading-${i}`}>
                      <button
                        className={
                          i === 0
                            ? `accordion-button ${Settings.Text.TitleFont} ${Settings?.Text?.TitleFontWeight}`
                            : `accordion-button collapsed ${Settings.Text.TitleFont} ${Settings?.Text?.TitleFontWeight}`
                        }
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target={`#collapse-${i}`}
                        aria-expanded="false"
                        aria-controls={`collapse-${i}`}
                        style={{ color: Settings?.Text?.TitleColor }}
                      >
                        {item.Title}
                        <div className="icon">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width={26}
                            height={14}
                            viewBox="0 0 26 14"
                            fill="none"
                          >
                            <path
                              d="M2.00031 1.53302L12.7559 12.066L23.5114 1.53302"
                              stroke="currentColor"
                              strokeWidth={3}
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </div>
                      </button>
                    </h2>
                    <div
                      id={`collapse-${i}`}
                      className={
                        i === 0
                          ? "accordion-collapse collapse show"
                          : "accordion-collapse collapse"
                      }
                      aria-labelledby={`heading-${i}`}
                      data-bs-parent="#accordionComponent"
                    >
                      <div className="accordion-body text-part">
                        <div
                          className={`${Settings?.Text?.DescriptionFont} ${Settings?.Text?.DescriptionFontWeight} mb-0`}
                          style={{ color: Settings?.Text?.DescriptionColor }}
                        >
                          <div
                            dangerouslySetInnerHTML={{
                              __html: item?.Description,
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </>
          );
        },
      },

      // HeaderTwoLogos2: {

      //     render: ({ logo1, link1, logo2, link2, Settings }) => {
      //         return (
      //             <div className="landing-page-wrapper">
      //                 <div className={`header-section ${Settings.Class}`}
      //                     style={
      //                         {
      //                             backgroundImage: `url("${Settings.Background.Image}")`,
      //                             backgroundColor: `${Settings.Background.Color}`,
      //                             backgroundPosition: `${Settings.Background.Position}`,
      //                             backgroundSize: `${Settings.Background.Size}`,
      //                             backgroundRepeat: `${Settings.Background.Repeat}`,
      //                             padding: `${Settings.Padding.Top}px ${Settings.Padding.Right}px ${Settings.Padding.Bottom}px ${Settings.Padding.Left}px`,
      //                         }
      //                     }
      //                 >
      //                     <div className="container">
      //                         <div className={`logo-wrapper d-flex justify-content-between ${Settings.Align}`}>
      //                             <Link to={link1}>
      //                                 <img src={logo1} alt="" style={{
      //                                     width: `${Settings?.Logo1Width}px`,
      //                                 }} />
      //                             </Link>
      //                             <Link to={link2}>
      //                                 <img src={logo2} alt="" style={{
      //                                     width: `${Settings?.Logo2Width}px`,
      //                                 }} />
      //                             </Link>

      //                         </div>
      //                     </div>
      //                 </div>
      //             </div>
      //         );
      //     },
      // },

      HeaderTwoLogos2: {
        render: ({ logo1, link1, logo2, link2, Settings }) => {
          return (
            <div className="landing-page-wrapper">
              <div
                className={`header-section ${Settings.Class}`}
                style={{
                  backgroundImage: `url("${Settings.Background.Image}")`,
                  backgroundColor: `${Settings.Background.Color}`,
                  backgroundPosition: `${Settings.Background.Position}`,
                  backgroundSize: `${Settings.Background.Size}`,
                  backgroundRepeat: `${Settings.Background.Repeat}`,
                  padding: `${Settings.Padding.Top}px ${Settings.Padding.Right}px ${Settings.Padding.Bottom}px ${Settings.Padding.Left}px`,
                }}
              >
                <div className="container">
                  <div
                    className={`logo-wrapper d-flex justify-content-between ${Settings.Align}`}
                  >
                    {link1 ? (
                      <Link to={link1}>
                        <img
                          src={logo1}
                          alt=""
                          style={{
                            width: `${Settings?.Logo1Width}px`,
                          }}
                        />
                      </Link>
                    ) : (
                      <img
                        src={logo1}
                        alt=""
                        style={{
                          width: `${Settings?.Logo1Width}px`,
                        }}
                      />
                    )}
                    {link2 ? (
                      <Link to={link2}>
                        <img
                          src={logo2}
                          alt=""
                          style={{
                            width: `${Settings?.Logo2Width}px`,
                          }}
                        />
                      </Link>
                    ) : (
                      <img
                        src={logo2}
                        alt=""
                        style={{
                          width: `${Settings?.Logo2Width}px`,
                        }}
                      />
                    )}
                  </div>
                </div>
              </div>
            </div>
          );
        },
      },

      Wrapper2: {
        render: ({ Padding, Background, Border, Class }) => {
          return (
            <>
              <div
                className={`component-wrapper ${Class}`}
                style={{
                  backgroundImage: `url("${Background.Image}")`,
                  backgroundColor: `${Background.Color}`,
                  backgroundPosition: `${Background.Position}`,
                  backgroundSize: `${Background.Size}`,
                  backgroundRepeat: `${Background.Repeat}`,
                  padding: `${Padding.top}px ${Padding.right}px ${Padding.bottom}px ${Padding.left}px`,
                  borderStyle: Border.BorderStyle,
                  borderColor: Border.BorderColor,
                  borderWidth: `${Border?.BorderWidth?.top}px ${Border?.BorderWidth?.right}px ${Border?.BorderWidth?.bottom}px ${Border?.BorderWidth?.left}px`,
                  borderRadius: `${Border.BorderRadius}px`,
                }}
              >
                {/* <div className='overlay'></div> */}
                <div className={`position-relative`}>
                  <DropZone zone="wrapper" />
                </div>
              </div>
            </>
          );
        },
      },

      ReportWhatsInside2: {
        render: ({ Heading, logo, items, Settings }) => {
          return (
            <>
              <div className="report-whats-inside bg-transparent report-build-wrapper">
                <div className="container">
                  <div className="text wrapper">
                    <div className="rep-heading">
                      <h2
                        className={`${Heading.fontWeight} ${Heading.titleFont}`}
                        style={{
                          textAlign: Heading.Align,
                        }}
                      >
                        {Heading.title}
                      </h2>
                    </div>
                    <div className="inside-main">
                      <div className="row">
                        {items.map((item, i) => (
                          <div className="col-lg-4 col-md-4" key={i}>
                            <div
                              className="inside-wrapper"
                              style={{
                                textAlign: Settings.Align,
                              }}
                            >
                              <h4
                                className={`${Settings.CouterFontSize} ${Settings.CounterFontWeight} background-clip-text`}
                                style={{
                                  background: `-webkit-linear-gradient(${Settings.CounterColor.Rotation}deg, ${Settings.CounterColor.Color1}, ${Settings.CounterColor.Color2})`,

                                  WebkitTextStroke: `${Settings.CounterColor.Stroke}px transparent`,
                                  color: `${Settings.CounterColor.InnerColor}`,
                                }}
                              >
                                {String(i + 1).padStart(2, "0")}
                              </h4>
                              <p
                                className={`${Settings.TitleFontSize}`}
                                style={{
                                  color: Settings.TitleColor,
                                }}
                              >
                                {item.Title}
                              </p>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="report-footer-logo">
                  <div className="container">
                    <div className="logo-wrap">
                      <img src={logo} alt="" />
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        },
      },

      Section2: {
        render: ({ Padding, Background, Settings }) => {
          return (
            <>
              <div
                className={`component-section ${Settings.Class} ${
                  Padding.bottom
                } ${Padding.top} ${Padding.fullHeight && "full-height"}`}
                style={{
                  backgroundImage: `url("${Background.Image}")`,
                  backgroundColor: `${Background.Color}`,
                  backgroundPosition: `${Background.Position}`,
                  backgroundSize: `${Background.Size}`,
                  backgroundRepeat: `${Background.Repeat}`,

                  borderStyle: Settings?.Border?.BorderStyle,
                  borderColor: Settings?.Border?.BorderColor,
                  borderWidth: `${Settings?.Border?.BorderWidth?.top}px ${Settings?.Border?.BorderWidth?.right}px ${Settings?.Border?.BorderWidth?.bottom}px ${Settings?.Border?.BorderWidth?.left}px`,
                  borderRadius: `${Settings?.Border?.BorderRadius}px`,
                }}
              >
                {/* <div className='overlay'></div> */}
                <div className={`${Settings.Width} position-relative`}>
                  <DropZone zone="section" />
                </div>
              </div>
            </>
          );
        },
      },

      GradientWrapper: {
        render: ({ Padding, Style, Border, Class }) => {
          return (
            <>
              <div
                className={`gradient-border ${Class}`}
                style={{
                  borderRadius: Border.BorderRadius,
                  position: "relative",
                  background: "transparent",
                  padding: `${Padding.top}px ${Padding.right}px ${Padding.bottom}px ${Padding.left}px`,
                }}
              >
                {" "}
                <style
                  dangerouslySetInnerHTML={{
                    __html:
                      " .gradient-border::before { border-radius: " +
                      Border.BorderRadius +
                      "px; background: linear-gradient(to right, " +
                      Border.BorderColor1 +
                      ", " +
                      Border.BorderColor2 +
                      ", " +
                      Border.BorderColor3 +
                      ", " +
                      Border.BorderColor4 +
                      "); } .gradient-border::after { background-color: " +
                      Style?.BackgroundColor +
                      "; margin: " +
                      Border.BorderWidth +
                      "px; border-radius: " +
                      Border.BorderRadius +
                      "px; }",
                  }}
                />
                <div
                  className={`position-relative`}
                  style={{
                    borderRadius: Border.BorderRadius,
                    overflow: "hidden",
                  }}
                >
                  <DropZone zone="wrapper" />
                </div>
              </div>
            </>
          );
        },
      },

      Icon: {
        render: ({ Icon, Size, Settings }) => {
          return (
            <>
              <div className="image-wrapper">
                <img
                  src={Icon}
                  alt=""
                  className={`icon d-block ${Settings?.Align}`}
                  style={{
                    width: `${Size?.Width}px`,
                    height: `${Size?.Height}px`,
                  }}
                />
              </div>
            </>
          );
        },
      },

      Button: {
        render: ({
          buttonAction,
          buttonText,
          conditionalLogic,
          buttonLink,
          iconPosition,
          buttonStyle,
          buttonicon,
          icon,
          hide,
          customStyle,
          Style,
          spacing,
          IconSize,
        }) => {
          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div className="button-wrap" style={{ opacity: inputOpacity }}>
                {buttonicon === "yes"
                  ? (() => {
                      if (buttonAction == 1) {
                        return (
                          <button
                            actions={`${buttonAction}`}
                            onClick={() => {
                              window.location.replace(buildLoginUrl('EH_16'));
                            }}
                            className={`d-inline-flex align-items-center btn roi-btn-${buttonStyle} ${
                              customStyle
                                ? `custom-style ${Style?.Font?.fontWeight} ${Style?.Font?.fontSize}`
                                : ""
                            }`}
                            type="submit"
                            style={
                              customStyle
                                ? {
                                    backgroundColor: `${Style?.BackgroundColor}`,
                                    color: `${Style?.Font?.Color}`,
                                    padding: `${Style?.Padding?.top}px ${Style?.Padding?.right}px ${Style?.Padding?.bottom}px ${Style?.Padding?.left}px`,
                                    margin: `${Style?.Margin?.top}px ${Style?.Margin?.right}px ${Style?.Margin?.bottom}px ${Style?.Margin?.left}px`,

                                    borderStyle: Style?.Border?.BorderStyle,
                                    borderColor: Style?.Border?.BorderColor,
                                    borderWidth: `${Style?.Border?.BorderWidth?.top}px ${Style?.Border?.BorderWidth?.right}px ${Style?.Border?.BorderWidth?.bottom}px ${Style?.Border?.BorderWidth?.left}px`,
                                    borderRadius: `${Style?.Border.BorderRadius}px`,
                                    gap: `${spacing ? `${spacing}px` : "20px"}`,
                                  }
                                : {
                                    gap: `${spacing ? `${spacing}px` : "20px"}`,
                                  }
                            }
                          >
                            {(() => {
                              if (iconPosition === "left") {
                                if (customStyle) {
                                  return (
                                    <>
                                      {" "}
                                      <img
                                        src={icon}
                                        alt=""
                                        className={`btn-icon`}
                                        style={{
                                          width: `${IconSize?.Width}px`,
                                          height: `${IconSize?.Height}px`,
                                        }}
                                      />{" "}
                                      {buttonText}{" "}
                                    </>
                                  );
                                } else {
                                  return (
                                    <>
                                      {" "}
                                      <img
                                        src={icon}
                                        alt=""
                                        className={`btn-icon`}
                                        style={{
                                          width: `${IconSize?.Width}px`,
                                          height: `${IconSize?.Height}px`,
                                        }}
                                      />{" "}
                                      {buttonText}
                                    </>
                                  );
                                }
                              } else if (iconPosition === "right") {
                                if (customStyle) {
                                  return (
                                    <>
                                      {" "}
                                      {buttonText}{" "}
                                      <img
                                        src={icon}
                                        alt=""
                                        className={`btn-icon`}
                                        style={{
                                          width: `${IconSize?.Width}px`,
                                          height: `${IconSize?.Height}px`,
                                        }}
                                      />{" "}
                                    </>
                                  );
                                } else {
                                  return (
                                    <>
                                      {" "}
                                      {buttonText}{" "}
                                      <img
                                        src={icon}
                                        alt=""
                                        className={`btn-icon`}
                                        style={{
                                          width: `${IconSize?.Width}px`,
                                          height: `${IconSize?.Height}px`,
                                        }}
                                      />
                                    </>
                                  );
                                }
                              } else {
                                return (
                                  <>
                                    {" "}
                                    {buttonText}{" "}
                                    <img
                                      src={icon}
                                      alt=""
                                      className={`btn-icon`}
                                      style={{
                                        width: `${IconSize?.Width}px`,
                                        height: `${IconSize?.Height}px`,
                                      }}
                                    />
                                  </>
                                );
                              }
                            })()}
                          </button>
                        );
                      } else {
                        return (
                          <a
                            href={`${buttonLink}`}
                            target="_blank"
                            actions={`${buttonAction}`}
                            className={`d-inline-flex align-items-center btn roi-btn-${buttonStyle} ${
                              customStyle
                                ? `custom-style ${Style?.Font?.fontWeight} ${Style?.Font?.fontSize}`
                                : ""
                            }`}
                            type="submit"
                            style={
                              customStyle
                                ? {
                                    backgroundColor: `${Style?.BackgroundColor}`,
                                    color: `${Style?.Font?.Color}`,
                                    padding: `${Style?.Padding?.top}px ${Style?.Padding?.right}px ${Style?.Padding?.bottom}px ${Style?.Padding?.left}px`,
                                    margin: `${Style?.Margin?.top}px ${Style?.Margin?.right}px ${Style?.Margin?.bottom}px ${Style?.Margin?.left}px`,

                                    borderStyle: Style?.Border?.BorderStyle,
                                    borderColor: Style?.Border?.BorderColor,
                                    borderWidth: `${Style?.Border?.BorderWidth?.top}px ${Style?.Border?.BorderWidth?.right}px ${Style?.Border?.BorderWidth?.bottom}px ${Style?.Border?.BorderWidth?.left}px`,
                                    borderRadius: `${Style?.Border.BorderRadius}px`,
                                    gap: `${spacing ? `${spacing}px` : "20px"}`,
                                  }
                                : {
                                    gap: `${spacing ? `${spacing}px` : "20px"}`,
                                  }
                            }
                          >
                            {(() => {
                              if (iconPosition === "left") {
                                if (customStyle) {
                                  return (
                                    <>
                                      {" "}
                                      <img
                                        src={icon}
                                        alt=""
                                        className={`btn-icon`}
                                        style={{
                                          width: `${IconSize?.Width}px`,
                                          height: `${IconSize?.Height}px`,
                                        }}
                                      />{" "}
                                      {buttonText}{" "}
                                    </>
                                  );
                                } else {
                                  return (
                                    <>
                                      {" "}
                                      <img
                                        src={icon}
                                        alt=""
                                        className={`btn-icon`}
                                        style={{
                                          width: `${IconSize?.Width}px`,
                                          height: `${IconSize?.Height}px`,
                                        }}
                                      />{" "}
                                      {buttonText}
                                    </>
                                  );
                                }
                              } else if (iconPosition === "right") {
                                if (customStyle) {
                                  return (
                                    <>
                                      {" "}
                                      {buttonText}{" "}
                                      <img
                                        src={icon}
                                        alt=""
                                        className={`btn-icon`}
                                        style={{
                                          width: `${IconSize?.Width}px`,
                                          height: `${IconSize?.Height}px`,
                                        }}
                                      />{" "}
                                    </>
                                  );
                                } else {
                                  return (
                                    <>
                                      {" "}
                                      {buttonText}{" "}
                                      <img
                                        src={icon}
                                        alt=""
                                        className={`btn-icon`}
                                        style={{
                                          width: `${IconSize?.Width}px`,
                                          height: `${IconSize?.Height}px`,
                                        }}
                                      />
                                    </>
                                  );
                                }
                              } else {
                                return (
                                  <>
                                    {" "}
                                    {buttonText}{" "}
                                    <img
                                      src={icon}
                                      alt=""
                                      className={`btn-icon`}
                                      style={{
                                        width: `${IconSize?.Width}px`,
                                        height: `${IconSize?.Height}px`,
                                      }}
                                    />
                                  </>
                                );
                              }
                            })()}
                          </a>
                        );
                      }
                    })()
                  : (() => {
                      if (buttonAction == 1) {
                        return (
                          <button
                            actions={`${buttonAction}`}
                            onClick={() => {
                              window.location.replace(buildLoginUrl('EH_16'));
                            }}
                            className={`btn roi-btn-${buttonStyle} ${
                              customStyle
                                ? `custom-style ${Style?.Font?.fontWeight} ${Style?.Font?.fontSize}`
                                : ""
                            }`}
                            type="submit"
                            style={
                              customStyle
                                ? {
                                    backgroundColor: `${Style?.BackgroundColor}`,
                                    color: `${Style?.Font?.Color}`,
                                    padding: `${Style?.Padding?.top}px ${Style?.Padding?.right}px ${Style?.Padding?.bottom}px ${Style?.Padding?.left}px`,
                                    margin: `${Style?.Margin?.top}px ${Style?.Margin?.right}px ${Style?.Margin?.bottom}px ${Style?.Margin?.left}px`,

                                    borderStyle: Style?.Border?.BorderStyle,
                                    borderColor: Style?.Border?.BorderColor,
                                    borderWidth: `${Style?.Border?.BorderWidth?.top}px ${Style?.Border?.BorderWidth?.right}px ${Style?.Border?.BorderWidth?.bottom}px ${Style?.Border?.BorderWidth?.left}px`,
                                    borderRadius: `${Style?.Border.BorderRadius}px`,
                                  }
                                : {}
                            }
                          >
                            {buttonText}
                          </button>
                        );
                      } else {
                        return (
                          <a
                            href={`${buttonLink}`}
                            target="_blank"
                            actions={`${buttonAction}`}
                            className={`btn roi-btn-${buttonStyle} ${
                              customStyle
                                ? `custom-style ${Style?.Font?.fontWeight} ${Style?.Font?.fontSize}`
                                : ""
                            }`}
                            type="submit"
                            style={
                              customStyle
                                ? {
                                    backgroundColor: `${Style?.BackgroundColor}`,
                                    color: `${Style?.Font?.Color}`,
                                    padding: `${Style?.Padding?.top}px ${Style?.Padding?.right}px ${Style?.Padding?.bottom}px ${Style?.Padding?.left}px`,
                                    margin: `${Style?.Margin?.top}px ${Style?.Margin?.right}px ${Style?.Margin?.bottom}px ${Style?.Margin?.left}px`,

                                    borderStyle: Style?.Border?.BorderStyle,
                                    borderColor: Style?.Border?.BorderColor,
                                    borderWidth: `${Style?.Border?.BorderWidth?.top}px ${Style?.Border?.BorderWidth?.right}px ${Style?.Border?.BorderWidth?.bottom}px ${Style?.Border?.BorderWidth?.left}px`,
                                    borderRadius: `${Style?.Border.BorderRadius}px`,
                                    gap: `${spacing ? `${spacing}px` : "20px"}`,
                                  }
                                : {}
                            }
                          >
                            {buttonText}
                          </a>
                        );
                      }
                    })()}
              </div>
            </>
          );
        },
      },
    },
  };
  if (loading) {
    return <div>Loading...</div>;
  }
  console.log("<....>", TandCThird, TandCOption, flagLandingPage);
  



  return (
    <>
    
      <div
        dangerouslySetInnerHTML={{
          __html:
            "<style type='text/css'> :root { --font-family: " +
            themeSet["--font-family"] +
            "; --da-primary: " +
            themeSet["--da-primary"] +
            " !important; --da-secondary: " +
            themeSet["--da-secondary"] +
            " !important; --progress-1: " +
            themeSet["--progress-1"] +
            " !important; --progress-2: " +
            themeSet["--progress-2"] +
            " !important; --progress-3: " +
            themeSet["--progress-3"] +
            " !important; --progress-4: " +
            themeSet["--progress-4"] +
            " !important; --progress-5: " +
            themeSet["--progress-5"] +
            " !important; } </style>",
        }}
      />
      
      {/* landing page */}
       {displayForm === "Before survey" &&
      (flagLandingPage === 0 || params.mode === "preview") &&
        surveyLinkUrl === 1 && (
            <Render config={config} data={replacedContent} />
        )}
      {/* lead form */}
       {displayForm === "Before survey" &&
    (publishData === 1 || params.mode === "preview") &&
        (flagLandingPage === 2 || flagLandingPage === 1) &&
        surveyLinkUrl === 1 && (
          <>
            <div className="lead-gen-wrapper">
              <div className="row gx-0">
                <div className="col-lg-6 d-none d-lg-flex">
                  <div className="img-wrapper">
                    {leadImage ? (
                      <img src={leadImage} alt="bannerImg" />
                    ) : (
                      <img src={leadgenImage} alt="bannerImg" />
                    )}
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="text-wrapper">
                    {flagLandingPage === 1 && (
                      <div className="text-inner">
                        <div className="heading-wrapper">
                          <h1>{heading ?? ""}</h1>
                        </div>
                        <div className="form-wrapper">
                          <form onSubmit={formik.handleSubmit}>
                            <div className="row">
                              {leadFormData?.map((item) => (
                                <CustomInput
                                  fieldData={item}
                                  className={"mb-4"}
                                  key={item.su_name}
                                  formikData={formik}
                                />
                              ))}
                            </div>
                            {(TandC || TandCSecond || TandCThird) && (
                              <div className="">
                                <p>Terms & Conditions</p>
                              </div>
                            )}
                            {TandC && (
                              <>
                                <div className="terms-form-wrap">
                                  <div className="form-check">
                                    {TandCOption.term != false && (
                                      <>
                                        {" "}
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          id="TANDC"
                                          name="TANDC"
                                          onChange={(e) =>
                                            formik.setFieldValue(
                                              "TANDC",
                                              e.target.checked ? "on" : ""
                                            )
                                          }
                                          onBlur={formik.handleBlur}
                                        />
                                      </>
                                    )}

                                    <label
                                      className={"form-check-label"}
                                      htmlFor={`TANDC`}
                                      dangerouslySetInnerHTML={{
                                        __html: TandC,
                                      }}
                                    ></label>
                                  </div>
                                  {formik.touched.TANDC &&
                                    formik.errors.TANDC && (
                                      <div className="error">
                                        {" "}
                                        {formik.errors.TANDC}
                                      </div>
                                    )}
                                </div>
                              </>
                            )}
                            {TandCSecond && (
                              <>
                                <div className="terms-form-wrap">
                                  <div className="form-check">
                                    {TandCSecondOption.term != false && (
                                      <>
                                        {" "}
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          id="TANDCSECOND"
                                          name="TANDCSECOND"
                                          onChange={(e) =>
                                            formik.setFieldValue(
                                              "TANDCSECOND",
                                              e.target.checked ? "on" : ""
                                            )
                                          }
                                          onBlur={formik.handleBlur}
                                        />
                                      </>
                                    )}

                                    <label
                                      className={"form-check-label"}
                                      htmlFor={`TANDCSECOND`}
                                      dangerouslySetInnerHTML={{
                                        __html: TandCSecond,
                                      }}
                                    ></label>
                                  </div>
                                  {formik.touched.TANDCSECOND &&
                                    formik.errors.TANDCSECOND && (
                                      <div className="error">
                                        {" "}
                                        {formik.errors.TANDCSECOND}
                                      </div>
                                    )}
                                </div>
                              </>
                            )}
                            {TandCThird && (
                              <>
                                <div className="terms-form-wrap">
                                  <div className="form-check">
                                    {TandCThirdOption.term != false && (
                                      <>
                                        {" "}
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          id="TANDCTHIRD"
                                          name="TANDCTHIRD"
                                          onChange={(e) =>
                                            formik.setFieldValue(
                                              "TANDCTHIRD",
                                              e.target.checked ? "on" : ""
                                            )
                                          }
                                          onBlur={formik.handleBlur}
                                        />
                                      </>
                                    )}
                                    <label
                                      className={"form-check-label"}
                                      htmlFor={`TANDCTHIRD`}
                                      dangerouslySetInnerHTML={{
                                        __html: TandCThird,
                                      }}
                                    ></label>
                                  </div>
                                  {formik.touched.TANDCTHIRD &&
                                    formik.errors.TANDCTHIRD && (
                                      <div className="error">
                                        {" "}
                                        {formik.errors.TANDCTHIRD}
                                      </div>
                                    )}
                                </div>
                              </>
                            )}
                            <br />
                            <div
                              className="btn-wrapper"
                              style={{
                                display: "flex",
                                justifyContent: submitPosition,
                              }}
                            >
                              {subLoading ? (
                                <button
                                  className="btn btn-primary btn-icon"
                                  type="submit"
                                  disabled
                                >
                                  {"Loading..."}{" "}
                                  <div
                                    className="spinner-border text-light"
                                    role="status"
                                  >
                                    <span className="visually-hidden">
                                      Loading...
                                    </span>
                                  </div>
                                </button>
                              ) : (
                                <button
                                  className="btn btn-primary btn-icon"
                                  type="submit"
                                  disabled={params.mode === "preview"}
                                >
                                  {submitTitle ?? "Submit"}{" "}
                                  <Svg name="button-icon" />
                                </button>
                              )}
                            </div>
                          </form>
                        </div>
                      </div>
                    )}
                    {flagLandingPage === 2 && (
                      <div className="text-inner">
                        <div className="heading-wrapper">
                          <h1>Verify email</h1>
                          <p>
                            We've sent a 6-digit verification code to your email
                            address. Please enter it below to verify your email.
                          </p>{" "}
                        </div>
                        <div className="form-wrapper">
                          <div className="form-floating mb-4">
                            <input
                              className="form-control"
                              id="otp"
                              name="otp"
                              type="text"
                              placeholder="Enter otp"
                              value={otp}
                              onInput={(e) => {
                                setOtp(e.target.value);
                                setotpError(false);
                              }}
                              required
                              inputMode="numeric" // Only allow numeric input
                              maxLength={6}
                              onKeyPress={(e) => {
                                // Prevent non-numeric characters
                                const pattern = /^[0-9\b]+$/;
                                if (!pattern.test(e.key)) {
                                  e.preventDefault();
                                }
                              }}
                            />
                            <label htmlFor="otp">OTP</label>
                            {otpError ? (
                              <>
                                <div className="error">
                                  {!otpError ? "" : checkotp}
                                </div>
                              </>
                            ) : (
                              ""
                            )}
                            {/* <div className="additional-info d-flex justify-content-between mb__20 pt-1">
                                                        <div className="text-primary">
                                                            <b className="d-block">{formatTimer(timer)}</b>
                                                        </div>
                                                        <a disabled>
                                                            <b className={timerStarted ? "text-primary" : "text-secondary"}> Resend code</b>
                                                        </a>
                                                    </div> */}
                          </div>
                          <div
                            className="btn-wrapper"
                            style={{
                              display: "flex",
                              justifyContent: submitPosition,
                            }}
                          >
                            <button
                              className="btn btn-primary btn-icon"
                              type="submit"
                              onClick={otpVerify}
                            >
                              {"Verify"} <Svg name="button-icon" />
                            </button>
                          </div>
                        </div>
                      </div>
                    )}
                    <div className="desclaimer-text">
                      <p>
                        Your personal data will be processed in accordance
                        with&nbsp;{aiLandingCompanyName ?? ""}{" "}
                        <a
                          href="https://www.tatacommunications.com/policies/privacy/"
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          privacy policy
                        </a>{" "}
                        . By clicking submit you confirm that you have read and
                        understood the privacy policy.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </>
        )}
      {(publishData === 2 && params.mode !== "preview") ||
        (surveyLinkUrl === 0 && (
          <>
            <h1>Survey yet not published.</h1>
          </>
        ))}
    </>
  );
}

//